export const de = {
  today: "Heute",
  thisWeek: "Diese Woche",
  thisMonth: "Diesen Monat",
  timeWorked: "Zeitenmonitor",
  timeWorkedOfflineNotice:
    "Du bist gerade offline. Die Zeiten können sich erst bei der nächsten Verbindung zum Internet aktualisieren.",
  nobody: "Niemand",
  numberShort: "Nr.",
  monday: "Montag",
  tuesday: "Dienstag",
  wednesday: "Mittwoch",
  thursday: "Donnerstag",
  friday: "Freitag",
  saturday: "Samstag",
  sunday: "Sonntag",
  days: "Tage",
  day: "Tag",
  week: "Woche",
  weeks: "Wochen",
  month: "Monat",
  months: "Monate",
  year: "Jahr",
  years: "Jahre",
  yes: "Ja",
  no: "Nein",
  pleaseSelect: "Bitte wählen",
  all: "Alle",
  north: "N",
  south: "S",
  west: "W",
  east: "O",
  northWest: "NW",
  northEast: "NO",
  southWest: "SW",
  southEast: "SO",
  unknown: "Unbekannt",
  unknownDate: "Unbekanntes Datum",
  heading: "Bewegungsrichtung",
  speed: "Geschwindigkeit",
  accuracy: "Genauigkeit",
  timestamp: "Zeitpunkt",
  constructionSites: "Baustellen",
  constructionSiteUnknownTitle: "Unbekannt",
  constructionSiteUnknownDescription: "Baustelle nicht gefunden.",
  allEntries: "Alle",
  autocompleteClearLabel: "{label} zurücksetzen",
  addOptionPrefix: "",
  addOptionSuffix: "neu anlegen",
  employee: "Mitarbeitende/r",
  myAreas: "Meine Bereiche",
  aroundPlanning: "Rund um die Planung",
  serviceCategory: "Leistungskategorie",
  planning: "Planung",
  planningDescription: "Plane deine Aufträge.",
  planningDateRange: "Planungszeitraum",
  timeApproval: "Zeitenfreigabe",
  timeApprovalDescription: "Gib die Zeiten deiner Kolonnen frei.",
  timeApprovalDurationIsLoading: "Lädt...",
  timeApprovalArrivalDuration: "Anfahrtsdauer",
  timeApprovalDepartureDuration: "Abfahrtsdauer",
  timeApprovalCommuteTypeNotAllowed: "Unbekannter Typ",
  timeApprovalCommuteTypeNoCommute: "keine",
  timeApprovalCommuteTypeDriverHome: "Zuhause - Fahrer/in",
  timeApprovalCommuteTypeDriverSite: "Betriebshof - Fahrer/in",
  timeApprovalCommuteTypePassengerHome: "Zuhause - Beifahrer/in",
  timeApprovalCommuteTypePassengerSite: "Betriebshof - Beifahrer/in",
  absence: "Abwesenheit",
  absences: "Abwesenheiten",
  auslastungsplanung: "Kolonnenplanung",
  auslastungsplanungDescription: "Plane Kolonnen-Einsätze für Bauprojekte.",
  absencesDescription: "Übersicht und Verwaltung von geplanten Abwesenheiten.",
  absencesTitle: "Abwesenheitsplanung",
  absenceDateRangePickerLabel: "Zeitraum",
  absencePeriod: "Zeitraum",
  absenceCategory: "Art",
  absenceCategorySchool: "Schule",
  absenceCategorySickness: "Krankheit",
  absenceCategoryTraining: "Schulung/Weiterbildung",
  absenceCategoryVacation: "Urlaub",
  absenceCategoryLeisureTimeAccount: "Freizeitkonto",
  absenceNonWorkingDay: "Arbeitsfreier Tag",
  absenceNonWorkingDayInView: "Arbeitsfreier Tag in dieser Ansicht",
  absenceNonWorkingDaysInView: "Arbeitsfreie Tage in dieser Ansicht",
  absenceSickNoteInPaperForm: "AU liegt in Papierform vor",
  absenceNote: "Bemerkung",
  absenceDeleteButtonTimeEntriesTooltip:
    "Die Abwesenheit kann nicht gelöscht werden, da diese bereits an die Lohnbuchhaltung übermittelt wurde.",
  addAbsenceSuccess: "Abwesenheit erfolgreich hinzugefügt",
  updateAbsenceSuccess: "Abwesenheit erfolgreich bearbeitet",
  deleteAbsenceSuccess: "Abwesenheit erfolgreich gelöscht",
  absenceEditButton: "Bearbeiten",
  absenceFormEditHeadline: "Abwesenheit bearbeiten",
  absenceFormAddHeadline: "Abwesenheit hinzufügen",
  absenceFormLeisureTimeAccountAbbreviation: "FK",
  absenceFormVacationEntitlementAbbreviation: "UA",
  addAbsence: "Abwesenheit hinzufügen",
  absenceInfoText: "Mitarbeiter/in ist zum ausgewählten Zeitraum abwesend!",
  absenceDeleteModalTitle: "Abwesenheit löschen",
  absenceDeleteModalConfirm: "Verstanden",
  absencesToggleCalendarViewTooltip: "Kalenderansicht",
  absencesToggleTableViewTooltip: "Tabellenansicht",
  absencesLeisureAndVacationColumnsSelectLabel: "Spalten",
  absencesLeisureAndVacationColumnsSelectAll: "Alle",
  absencesLeisureAndVacationColumnsHeader: "Freizeit",
  absencesLeisureTimeAccountColumn: "Freizeitkonto",
  absencesUsedVacationDaysColumn: "Genommener Urlaub",
  absencesPlannedVacationDaysColumn: "Verplanter Urlaub",
  absencesRemainingVacationDaysColumn: "Übriger Urlaub",
  absencesLeisureTimeAccountColumnHeader: "Freizeitkonto",
  absencesUsedVacationDaysColumnHeader: "Genommen. Url.",
  absencesPlannedVacationDaysColumnHeader: "Verplanter Url.",
  absencesRemainingVacationDaysColumnHeader: "Übriger Url.",
  timeTrackingPositionModalConfirm: "Verstanden",
  absenceEmptySearchResult:
    "Für die ausgewählten Suchkriterien konnten keine Abwesenheiten gefunden werden.",
  absenceCategorySelectPlaceholder: "Art auswählen",
  absenceMinDateError:
    "Das Datum darf maximal 1 Jahr in der Vergangenheit liegen",
  absenceEndDateBeforeLastTimeEntryError:
    "Das Enddatum der Abwesenheit muss weiter in der Zukunft liegen, da bereits Zeiten für dieses Datum exportiert wurden.",
  absenceOverlappingError: "Für den Zeitraum besteht bereits eine Abwesenheit.",
  absenceInfoModalTitle: "Abwesenheit von {employeeName}",
  absenceInfoModalEmployeeUnknown: "Unbekannt",
  absenceInfoModalAbsenceDeleted:
    "Zugehörige Abwesenheitsplanung wurde gelöscht.",
  nominalAccounts: "Sachkonten",
  nominalAccountsDescription:
    "Übersicht der Sachkonten zur Überprüfung der Buchung. ",
  nominalAccountsTableHeaderNumber: "Sachkonto-Nr.",
  nominalAccountsTableHeaderDescription: "Bezeichnung",
  nominalAccountsTableHeaderAccountType: "Kontoart",
  nominalAccountsTableHeaderUseage: "Verwendung",
  nominalAccountsTableHeaderPostings: "Buchungen",
  endDateAfterStartDate: "Startdatum muss vor Enddatum liegen",
  timeRange: "Zeitraum",
  loading: "Lade Daten",
  photoGallery: "Foto-Galerie",
  projectsJournal: "Baubuch",
  projectsJournalDescription: "Sieh wie gut deine Baustellen laufen.",
  projectsJournalBreadcrumbs: "Baubuch",
  projectsJournalFilterButtonLabel: "Filter",
  projectsJournalResetAllFiltersLabel: "Alle Filter zurücksetzen",
  controllingAccountSubgroupFilter: "Konten",
  controllingAccountSubgroupAll: "Alle Buchungen",
  controllingAccountSubgroupLabelToolsInternal: "Intern",
  controllingAccountSubgroupLabelToolsExternal: "Extern",
  controllingAccountSubgroupLabelForeignInternal: "Intern",
  controllingAccountSubgroupLabelForeignExternal: "Extern",
  controllingAccountSubgroupLabelRevenueInvoiced: "geschr.AbRe.",
  controllingAccountSubgroupLabelRevenuePartiallyPaid: "erhaltene Anzahlungen",
  controllingAccountSubgroupLabelRevenueProceeds: "Erlöse",
  controllingProjectsViewSettingsButtonLabel: "Ansicht",
  controllingProjectsViewSettingsColumnsLabel: "Spalten",
  controllingProjectsViewSettingsColumnsResultLabel: "Ergebnis",
  controllingProjectsViewSettingsColumnsCostsLabel: "Einzelkosten",
  controllingProjectsViewSettingsColorSignalsLabel: "Farbsignale",
  controllingProjectsViewSettingsColorSignalsOnLabel: "An",
  controllingProjectsViewSettingsColorSignalsOffLabel: "Aus",
  controllingProjectsViewSettingsCloseLabel: "Schließen",
  controllingProjectsFilterLabel: "Projekte",
  controllingProjectsFilterPlaceholder: "Projekte auswählen",
  controllingCostObjectsFilterLabel: "Leistungsverzeichnisse",
  controllingCostObjectsFilterPlaceholder: "Leistungsverzeichnisse auswählen",
  controllingBusinessLineFilterLabel: "Geschäftsfelder (Auftragsverwaltung)",
  controllingBusinessLineFilterPlaceholder: "Geschäftsfelder auswählen",
  controllingServiceCategoryFilterLabel: "Leistungskategorien (Arbeitspakete)",
  controllingServiceCategoryOrderManagementFilterLabel:
    "Leistungskategorien (Auftragsverwaltung)",
  controllingServiceCategoryFilterPlaceholder: "Leistungskategorien auswählen",
  controllingProjectsManagersFilterLabel: "Bauleiter",
  controllingProjectsClientNamesFilterLabel: "Auftraggeber",
  controllingProjectsTenantFilterLabel: "Mandant",
  controllingProjectsTenantFilterTemplatesLabel: "Vorlagen",
  controllingProjectsTenantFilterTenantsLabel: "Mandanten",
  controllingProjectsTenantColumnLabel: "Mandant",
  controllingProjectsServiceCategoriesDataflorFilterLabel:
    "Leistungskategorien (DATAflor)",
  controllingProjectsBusinessLinesDataflorFilterLabel:
    "Geschäftsfelder (DATAflor)",
  controllingProjectsToolCostCentersFilterLabel: "Gerätebaustellen",
  controllingProjectsToolCostCentersFilterTooltipChecked:
    "Mit Gerätebaustellen",
  controllingProjectsToolCostCentersFilterTooltipUnchecked:
    "Ohne Gerätebaustellen",
  controllingDateRangeFilterLabel: "Buchungszeitraum",
  controllingProjectsNoProjectsFound:
    "Für die ausgewählten Suchkriterien konnten keine Projekte gefunden werden",
  controllingProjectsCopyNumberTooltip:
    "Zum Kopieren der Projektnummer klicken.",
  controllingProjectsCopyNumberToast:
    "Die Projektnummer wurde in die Zwischenablage kopiert.",
  controllingProjectsCopyCostObjectNumberTooltip:
    "Zum Kopieren der Leistungsverzeichnisnummer klicken.",
  controllingProjectsCopyCostObjectNumberToast:
    "Die Leistungsverzeichnisnummer wurde in die Zwischenablage kopiert.",
  controllingProjectsProject: "Projekt",
  controllingProjectsProjectLong: "Projekt in DATAflor",
  controllingProjectsProjectGlossaryText: null,
  controllingProjectsProjectCostObjectFilterWarning:
    "Beachte, dass bei Filterung nach Leistungsverzeichnissen nur die gefilterten Leistungsverzeichnisse auf Projektebene aufsummiert werden.",
  controllingProjectsStatus: "Status",
  controllingProjectsStatusLong: "Status der Baustelle in DATAflor",
  controllingProjectsStatusGlossaryText: null,
  controllingProjectsLastOutgoingInvoiceAt: "Letz. Rechn.",
  controllingProjectsLastOutgoingInvoiceAtLong:
    "Letzte Rechnung die in der Buchhaltung gebucht ist. ",
  controllingProjectsLastOutgoingInvoiceAtGlossaryText: null,
  controllingProjectsLastIncomingInvoiceAt: "Letz. Buch.",
  controllingProjectsLastIncomingInvoiceAtLong:
    "Letzte Kostenbuchung auf die Baustelle in der Buchhaltung.",
  controllingProjectsLastIncomingInvoiceAtGlossaryText: null,
  controllingProjectsLastInvoicesAtInaccurateWarning:
    "Beachte, dass bei gesetztem Buchungszeitraum-Filter das Datum der letzten Buchung und letzten Rechnung entsprechend dem Zeitraum angepasst wird. Es kann Buchungen und Rechnungen vor bzw. nach dem ausgewählten Zeitraum geben.",
  controllingProjectStatus_completed: "Abgeschlossen",
  controllingProjectStatus_in_progress: "In Bearbeitung",
  controllingProjectStatus_unstarted: "Bevorstehend",
  controllingProjectStatus_archived: "Archiviert",
  controllingProjectStatus_unknown: "Unbekannt",
  controllingProjectStatusTooltip_completed:
    'Alle LVs des Projektes sind im DATAflor "BZ"',
  controllingProjectStatusTooltip_in_progress:
    'Mindestens ein LV des Projektes ist im DATAflor "BE, BB, BS". Sofern kein Status BE/BB/BS ist, aber BA und BZ vorhanden sind, wird das Projekt ebenfalls als "In Bearbeitung" angezeigt',
  controllingProjectStatusTooltip_unstarted:
    'Alle LVs des Projektes sind im DATAflor "BA"',
  controllingProjectStatusTooltip_archived:
    "Das Projekt wurde in DATAflor archiviert",
  controllingProjectStatusTooltip_unknown:
    "Es ist kein beauftragtes LV vorhanden",
  controllingProjectsProductiveHours: "Prod.-Std.",
  controllingProjectsProductiveHoursLong:
    "Produktivstunden die in der Lohnbuchhaltung auf die Baustelle gebucht sind.",
  controllingProjectsProductiveHoursGlossaryText: null,
  controllingProjectsProfitContributionPerHourTotal: "DB / Std.",
  controllingProjectsProfitContributionPerHourTotalLong:
    "Aktueller Deckungsbeitrag pro Stunde der Baustelle",
  controllingProjectsProfitContributionPerHourTotalGlossaryText: null,
  controllingProjectsMinimumInvoiceAmountTotal: "MAB",
  controllingProjectsMinimumInvoiceAmountTotalLong:
    "Mindestabrechnungsbetrag, um den Zieldeckungsbeitrag relativ zu erreichen.",
  controllingProjectsMinimumInvoiceAmountTotalGlossaryText: null,
  controllingProjectsMinimumInvoiceAmountTotalInaccurateWarning:
    "Beachte, dass bei gesetztem Buchungszeitraum-Filter die Herstellkosten und die Produktivstunden entsprechend dem Zeitraum angepasst werden. Daher kann sich auch der MAB verändern, da zur Berechnung die Daten entsprechend dem Buchungszeitraum-Filter herangezogen werden.",
  controllingProjectsCosts: "Herstellkosten",
  controllingProjectsCostsLong:
    "Alle Herstellkosten der Baustelle ohne Zuschläge",
  controllingProjectsCostsGlossaryText: null,
  controllingProjectsRevenue: "Geschr. Rechnungen",
  controllingProjectsRevenueLong:
    "In der Buchhaltung gebuchte Erlöse und erhaltene Anzahlungen der Baustelle",
  controllingProjectsRevenueGlossaryText: null,
  controllingProjectsProfitContribution: "DB (abs.)",
  controllingProjectsProfitContributionLong:
    "Gesamter Deckungsbeitrag (absolut)",
  controllingProjectsProfitContributionGlossaryText: null,
  controllingProjectsProfitContributionPercentage: "DB (rel.)",
  controllingProjectsProfitContributionPercentageLong:
    "Relativer Deckungungsbeitrag",
  controllingProjectsProfitContributionPercentageGlossaryText: null,
  controllingProjectsMarkedProjectsCountPlural:
    "<b>{count} Einträge</b> ausgewählt",
  controllingProjectsMarkedProjectsCountSingular:
    "<b>{count} Eintrag</b> ausgewählt",
  controllingProjectsMarkedProjectsAsFilter: "Als Filter übernehmen",
  controllingProjectsMarkedProjectsClear: "Zurücksetzen",
  controllingProjectsCostObjectsBarLabel: "{count} Leistungsverzeichnisse",
  controllingProjectsCostObjectsFilteredBarLabel:
    "{count} von {totalCount} Leistungsverzeichnissen",
  controllingProjectsMarkCheckboxLabel: "{projectNumber} auswählen",
  controllingProjectsMarkAllCheckboxLabel: "Alle Projekte auswählen",
  controllingProjectsMarkAllCheckboxTooManyItemsTooltip:
    "Es können nur alle Projekte markiert werden, wenn das Ergebnis weniger als 100 Einträge hat.",
  controllingProjectsActualAriaLabel: "Ist",
  controllingProjectsTargetAriaLabel: "Soll",
  controllingProjectDetailsTotalActual: "Ist",
  controllingProjectDetailsTotalTarget: "Gesamt-Soll",
  controllingProjectDetailsDelta: "Gesamt-Delta",
  controllingProjectDetailsSums: "Summen",
  controllingProjectDetailsMonths: "Monate",
  controllingProjectDetailsInaccurateWarning:
    "Beachte, dass bei gesetztem Buchungszeitraums-Filter die Soll-Zahlen nicht entsprechend errechnet werden können. Die Zahlen beziehen sich ausschließlich auf den gesamten Buchungszeitraum.",
  controllingProjectDetailsProfitContribution: "Deckungsbeitrag",
  controllingProjectDetailsProfitContributionLong:
    "Absoluter Deckungsbeitrag der Baustelle laut Buchhaltung",
  controllingProjectDetailsProfitContributionGlossaryText:
    "Der Deckungsbeitrag (DB) ist in der Kosten- und Leistungsrechnung die Differenz zwischen den erzielten/ erzielbaren Erlösen (Umsatz) und den variablen Kosten. Es handelt sich also um den Betrag, der zur Deckung der Fixkosten zur Verfügung steht. Sind die Fixkosten vollständig gedeckt, ist der darüber hinaus gehende Überschuss gleich dem Gewinn vor Steuern.",
  controllingProjectDetailsRevenue: "Geschriebene Rechnungen",
  controllingProjectDetailsRevenueLong:
    "In der Buchhaltung gebuchte Erlöse, erhaltene Anzahlungen und geschriebene Abschlagsrechnungen der Baustelle.",
  controllingProjectDetailsRevenueGlossaryText:
    "Erlöse: Wertmäßige Erfassung des Absatzes von Produkten oder Dienstleistungen eines Unternehmens. Wird auch als Umsatz bezeichnet." +
    "<br><br>" +
    "Erhaltene Anzahlungen: Auf den Konten des Unternehmens eingegangene Zahlung des Kunden auf eine Abschlagsrechnung. Umbuchung im Baubuch von geschriebene Abschlagsrechnung auf erhaltene Anzahlung." +
    "<br><br>" +
    "Geschriebene Abschlagsrechnungen: Teilrechnung für erbrachte, aber nicht vollständig abgeschlossene Leistungen auf einer Baustelle oder bei einer Dienstleitung. Abschlagsrechnungen sind nicht erlöswirksam. Abschlagsrechnungen müssen bei einem VOB-Vertrag vom Kunden innerhalb von 18 Tagen geprüft und bezahlt werden.",
  controllingProjectDetailsRevenueProceeds: "Erlöse",
  controllingProjectDetailsRevenueProceedsLong: "Erlöse",
  controllingProjectDetailsRevenueProceedsGlossaryText: null,
  controllingProjectDetailsRevenuePartiallyPaid: "Erhaltene Anzahlungen",
  controllingProjectDetailsRevenuePartiallyPaidLong: "Erhaltene Anzahlungen",
  controllingProjectDetailsRevenuePartiallyPaidGlossaryText: null,
  controllingProjectDetailsRevenueInvoiced: "Geschr. Abschlagsrechnungen",
  controllingProjectDetailsRevenueInvoicedLong:
    "Geschriebene Abschlagsrechnungen",
  controllingProjectDetailsRevenueInvoicedGlossaryText: null,
  controllingProjectDetailsCostsTotal: "Kosten",
  controllingProjectDetailsCostsTotalLong:
    "Alle Herstellkosten der Baustelle ohne Zuschläge laut Buchhaltung",
  controllingProjectDetailsCostsTotalGlossaryText:
    "Herstellkosten (HK) sind ein Kostenbestandteil im Kalkulationsschema der Baupreisbildung. Sie setzen sich als Summe betriebswirtschaftlich zusammen aus den Einzelkosten der Teilleistungen (EKT) und den Baustellengemeinkosten (BGK).",
  controllingProjectDetailsCostsWages: "Lohn",
  controllingProjectDetailsCostsWagesLong:
    "Auf die Baustelle gebuchter Kosten für Lohn",
  controllingProjectDetailsCostsWagesGlossaryText:
    "Als Produktivstunden gelten die Arbeitsstunden, die für abrechenbare Leistungen erbracht werden und direkt an den Kunden fakturiert werden können. Es sind die tatsächlich auf der Baustelle erbrachten Arbeitsstunden ohne Pausenzeiten, Wegezeiten, Krankenzeiten und Fortbildungszeiten.",
  controllingProjectDetailsCostsTools: "Gerät",
  controllingProjectDetailsCostsToolsLong:
    "Auf die Baustelle gebuchte Kosten für Geräte",
  controllingProjectDetailsCostsToolsGlossaryText: null,
  controllingProjectDetailsCostsMaterials: "Material",
  controllingProjectDetailsCostsMaterialsLong:
    "Auf die Baustelle gebuchtes Kosten für Material",
  controllingProjectDetailsCostsMaterialsGlossaryText: null,
  controllingProjectDetailsCostsMisc: "Sonstiges",
  controllingProjectDetailsCostsMiscLong:
    "Auf die Baustelle gebuchte sonstige Kosten",
  controllingProjectDetailsCostsMiscGlossaryText: null,
  controllingProjectDetailsCostsPlants: "Pflanzen",
  controllingProjectDetailsCostsPlantsLong:
    "Auf die Baustelle gebuchte Kosten für Pflanzen",
  controllingProjectDetailsCostsPlantsGlossaryText: null,
  controllingProjectDetailsCostsForeign: "Fremd",
  controllingProjectDetailsCostsForeignLong:
    "Auf die Baustelle gebuchte Kosten für Fremdleistungen",
  controllingProjectDetailsCostsForeignGlossaryText: null,
  controllingProjectDetailsCostsDisposal: "Entsorgung",
  controllingProjectDetailsCostsDisposalLong:
    "Auf die Baustelle gebuchte Kosten für Entsorgungsleistungen",
  controllingProjectDetailsCostsDisposalGlossaryText: null,
  controllingProjectDetailsCostsOverheads: "BGK",
  controllingProjectDetailsCostsOverheadsLong: "Baustellengemeinkosten",
  controllingProjectDetailsCostsOverheadsGlossaryText:
    "Grundsätzlich sind die Baustellengemeinkosten, die Kosten einer Baustelle, die keiner Position zuzuordnen sind. In unserer Darstellung des Baubuches hier sind die Baustellengemeinkosten aktuell nur die Kosten, die durch das Wegegeld entstanden sind.",
  controllingProjectEntriesModalHeaderText: "Buchungstext",
  controllingProjectEntriesModalHeaderJournalEntryDate: "Belegdatum",
  controllingProjectEntriesModalHeaderJournalEntryBookingDate: "Buchungsdatum",
  controllingProjectEntriesModalHeaderNumber: "Belegnummer",
  controllingProjectEntriesModalHeaderCustomer: "Kunde/Lieferant",
  controllingProjectEntriesModalHeaderCost: "Aufwand",
  controllingProjectEntriesModalHeaderRevenue: "Erlös",
  controllingProjectEntriesModalHeaderEmployee: "Arbeitnehmer",
  controllingProjectEntriesModalHeaderWageType: "Lohnart",
  controllingProjectEntriesModalHeaderWageEntryDate: "Datum",
  controllingProjectEntriesModalHeaderHours: "Stunden",
  controllingProjectEntriesModalHeaderWageCosts: "Lohn",
  controllingProjectsUnknownEmployee: "Unbekannt",
  controllingProjectsFooterTotal: "Gesamt",
  controllingProjectsFooterProjects: "Projekte",
  controllingProjectMetaInfoDialogTitle: "Projekt {projectNumber}",
  controllingProjectMetaInfoInformationSectionTitle: "Informationen",
  controllingProjectMetaInfoDescriptionLabel: "Beschreibung",
  controllingProjectMetaInfoClientsLabel: "Auftraggeber",
  controllingProjectMetaInfoBusinessLineLabel:
    "Geschäftsfeld (Auftragsverwaltung)",
  controllingProjectMetaInfoBusinessLinesDataflorLabel:
    "Geschäftsfelder (DATAflor)",
  controllingProjectMetaInfoServiceCategoryOrderManagementLabel:
    "Leistungskategorien (Auftragsverwaltung)",
  controllingProjectMetaInfoServiceCategoriesLabel:
    "Leistungskategorien (Arbeitspakete)",
  controllingProjectMetaInfoServiceCategoriesDataflorLabel:
    "Leistungskategorien (DATAflor)",
  controllingProjectMetaInfoSuppliersLabel: "Lieferanten",
  controllingProjectMetaInfoEmployeesLabel:
    "Beteiligte gewerbliche Mitarbeiter",
  controllingProjectMetaInfoUnknownEmployee:
    "Unbekannter Mitarbeiter: {staffNumber}",
  controllingProjectSynchronizationButtonLabel: "Synchronisieren",
  controllingProjectSynchronizationButtonTooltip: "Projekt synchronisieren",
  controllingProjectSynchronizationToastSuccessful:
    "Synchronisierung abgeschlossen",
  controllingProjectSynchronizationToastFailed:
    "Synchronisierung fehlgeschlagen",
  controllingProjectMinimumInvoiceAmountProfitContributionWarning:
    "Es ist kein kalkulierter DB (REL.) hinterlegt.",
  controllingProjectWageEntryExportButtonLabel: "Export Lohn",
  controllingProjectWageEntryExportCsvStaffNumber: "Personalnummer",
  controllingProjectWageEntryExportCsvFirstName: "Vorname",
  controllingProjectWageEntryExportCsvLastName: "Nachname",
  controllingProjectWageEntryExportCsvWageTypeNumber: "Lohnnummer",
  controllingProjectWageEntryExportCsvWageType: "Lohnart",
  controllingProjectWageEntryExportCsvDate: "Datum",
  controllingProjectWageEntryExportCsvWageHours: "Stunden",
  controllingProjectWageEntryExportCsvWageCosts: "Lohn",
  controllingProjectSortMenuLabelActualAscending: "Aufsteigend nach Ist-Zahlen",
  controllingProjectSortMenuLabelActualDescending: "Absteigend nach Ist-Zahlen",
  controllingProjectSortMenuLabelTargetAscending:
    "Aufsteigend nach Soll-Zahlen",
  controllingProjectSortMenuLabelTargetDescending:
    "Absteigend nach Soll-Zahlen",
  controllingProjectSortMenuAbbreviationActual: "I",
  controllingProjectSortMenuAbbreviationTarget: "S",
  controllingHoursEvaluations: "Stundenauswertung",
  controllingHoursEvaluationsDescription: "Stundenauswertung",
  controllingHourEvaluationsPageHeader: "Stundenauswertung",
  controllingHourEvaluationsChargeableHours: "Produktiv",
  controllingHourEvaluationsPreparation: "Lade- und Rüstzeit",
  controllingHourEvaluationsCommuting: "Wegegeld-Fahrzeit",
  controllingHourEvaluationsVacation: "Urlaub",
  controllingHourEvaluationsIllness: "Krankheit",
  controllingHourEvaluationsTraining: "Weiterbildung",
  controllingHourEvaluationsAdministration: "Administration",
  controllingHourEvaluationsLeisureTime: "Freizeitkonto",
  controllingHourEvaluationsBadWeather: "Schlechtwetter",
  controllingHourEvaluationsWageTypeTotal: "Gesamt",
  controllingHourEvaluationsWageTypeTotalTooltip: "Enthält alle Lohnarten",
  controllingHourEvaluationsProductiveHours: "Produktivzeit",
  controllingHourEvaluationsProductiveHoursTooltip:
    "Enthält die Lohnarten Produktiv und Lade- und Rüstzeit",
  controllingHourEvaluationsHours: "Stunden",
  controllingHourEvaluationsProductiveWithCommutingHours:
    "Produktivzeit zzgl. Wegegeld-Fahrzeit",
  controllingHourEvaluationsProductiveToTotalHoursRatio:
    "Verhältnis Produktivzeit zu Gesamt",
  controllingHourEvaluationsCommutingToTotalHoursRatio:
    "Verhältnis Wegegeld-Fahrzeit zu Gesamt",
  controllingHourEvaluationsIllnessToTotalHoursRatio:
    "Verhältnis Krankheit zu Gesamt",
  controllingHourEvaluationsTrainingToTotalHoursRatio:
    "Verhältnis Weiterbildung zu Gesamt",
  controllingHourEvaluationsBankHolidays: "Feiertage",
  controllingHourEvaluationsGroupingSelectLabel: "Anzeigen nach...",
  controllingHourEvaluationsGroupingSelectBusinessLine:
    "Lohnart > Geschäftsfeld > Mitarbeitende",
  controllingHourEvaluationsGroupingSelectEmployee:
    "Lohnart > Mitarbeitende > Geschäftsfeld",
  controllingProfitContributionReport: "Deckungsbeitrags-Report",
  controllingProfitContributionReportDescription: "Deckungsbeitrags-Report",
  controllingProfitContributionReportOverheadCosts: "Gemeinkosten",
  controllingProfitContributionReportRevenueWithoutSites:
    "Umsätze ohne Baustelle",
  controllingProfitContributionReportProfiContributionTooltip:
    "Deckungsbeitrag",
  controllingProfitContributionNoEmployee: "Kein Bauleiter",
  controllingProfitContributionTotal: "Σ Gesamt",
  controllingProfitContributionReportProfitContribution: "Deckungsbeitrag",
  controllingProfitContributionReportProfitContributionShort: "DB",
  controllingProfitContributionReportProfitContributionDelta: "DB Δ",
  controllingProfitContributionReportRevenue: "Umsatz",
  controllingProfitContributionReportRevenueDelta: "Um. Δ",
  controllingProfitContributionReportPercentage: "Prozentual",
  controllingProfitContributionReportYearlyPlanRevenue:
    "Gesamt-Jahresplanung Umsatz",
  controllingProfitContributionReportYearlyPlanProfitContribution:
    "Gesamt-Jahresplanung DB",
  controllingProfitContributionReportYearlyPlanDeviation:
    "Abweichung zur Jahresplanung",
  controllingProfitContributionReport_totalBeforeCurrentMonth:
    "Gesamt bis zum letzten abgeschlossenen Monat",
  controllingProfitContributionReport_total: "Gesamt {year}",
  controllingProfitContributionReportViewOption: "Ansicht nach",
  controllingProfitContributionReportViewOptionConstructionSiteManager:
    "Bauleiter",
  controllingProfitContributionReportViewOptionGmbH: "GmbH",
  controllingProfitContributionReportViewOptionBusinessLine: "Geschäftsfeld",
  controllingRevenueReport: "Abrechnungs-Report",
  controllingRevenueReportDescription: "Abrechnungs-Report",
  controllingRevenueReportColumnTenant: "Mandant",
  controllingRevenueReportColumnRevenue: "Umsatz",
  controllingRevenueReportColumnDelta: "Δ",
  controllingRevenueReportColumnCalendarWeek: "KW {weekNumber}",
  controllingRevenueReportColumnTotal: "Kumuliert {year}",
  controllingRevenueReportColumnTitleCompany: "Σ Gesamt",
  controllingRevenueReportColumnTitleCompanyPreviousYear: "Σ Gesamt Vorjahr",
  controllingRevenueReportYearlyPlanRevenue: "Gesamt-Jahresplanung Umsatz",
  controllingRevenueReportYearlyPlanDeviation:
    "Abweichung zur Gesamt-Jahresplanung",
  controllingRevenueReportYearlyActualRevenue: "Erreichter Jahresumsatz",
  controllingRevenueReportTenantFilterLabel: "Mandant",
  nalDashboard: "NAL",
  nalDashboardDescription: "NAL-Prozess verwalten",
  nalDashboardBreadcrumbs: "NAL",
  nalOpenPeriodButtonLabel: "{period} eröffnen",
  nalOpenPeriodModalTitle: "Periode {monthName} {year} eröffnen",
  nalOpenPeriodSubmitButton: "Periode eröffnen",
  nalOpenPeriodPreviousNotClosedTooltip:
    "Die vorherige Periode muss erst final freigegeben werden.",
  nalEntryDeadlineTitle: "Erfassungsfrist (BL)",
  nalEntryDeadlineDescription:
    "Bis zu diesem Termin sollen Bauleiter die noch abzurechnenden Leistungen erfassen. Alle Bauleiter erhalten mit der Eröffnung eine Email-Benachrichtigung über die Frist.",
  nalEntryDeadlineLabel: "Datum",
  nalReleaseDeadlineTitle: "Freigabefrist (GF)",
  nalReleaseDeadlineDescription:
    "Bis zu diesem Termin sollen Geschäftsführer die noch abzurechnenden Leistungen prüfen und freigeben. Alle Geschäftsführer erhalten mit der Eröffnung eine Email-Benachrichtigung über die Frist.",
  nalReleaseDeadlineLabel: "Datum",
  nalDeadlineMustBeFuture: "Frist muss in der Zukunft liegen",
  nalDeadlineRequired: "Frist erforderlich",
  nalReleaseAfterEntry: "Freigabefrist muss nach Erfassungsfrist liegen",
  nalPeriodOpenedSuccess: "NAL-Periode erfolgreich eröffnet",
  nalPeriodOpenedError: "Fehler beim Eröffnen der NAL-Periode",
  nalPeriodSeedSectionTitle: "NAL-Testdaten (nur Staging/Development)",
  nalPeriodSeedSelectLabel: "Periode",
  nalPeriodSeedOpenButton: "Periode eröffnen",
  nalPeriodSeedOpenSuccess: "Periode erfolgreich eröffnet",
  nalPeriodSeedOpenError: "Fehler beim Eröffnen der Periode",
  nalPeriodSeedDeleteButton: "NAL-Daten löschen",
  nalPeriodSeedDeleteSuccess: "NAL-Daten erfolgreich gelöscht",
  nalPeriodSeedDeleteError: "Fehler beim Löschen der NAL-Daten",
  nalPeriodSeedThirteenthRunLabel: "13. Lauf {year}",
  nalEvaluationSaveError: "Fehler beim Speichern der NAL-Bewertung",
  constructionSiteManagerEvaluationNal: "NAL",
  constructionSiteManagerEvaluationNalLong: "Nicht abgerechnete Leistungen",
  constructionSiteManagerEvaluationNalTooltipDescription:
    "Verbuchte Lieferungen und Leistungen, die bereits auf der Baustelle erbracht wurden, aber noch nicht an den Kunden berechnet sind. Diese sind im Rahmen der monatlichen Bewertung (Stichtag: letzter Tag im Monat) der HFL anzusetzen.",
  constructionSiteManagerEvaluationNzla: "NZLA",
  constructionSiteManagerEvaluationNzlaLong:
    "Noch zu leistende Arbeiten – noch zu Leistende",
  constructionSiteManagerEvaluationNzlaTooltipDescription:
    "Leistungen, die per Leistungsanregung auf den Baustellen an den Kunden abgerechnet wurden und Material, welches bereits vor Auslieferung durch den Lieferanten und Verbuchung vom Kunden per Vorkasse bezahlt wurde. Diese sind im Rahmen der monatlichen Bewertung der HFL anzusetzen.",
  constructionSiteManagerEvaluationNalBillingCalendarWeek: "NAL Abr. in KW",
  constructionSiteManagerEvaluationNalBillingCalendarWeekLong:
    "Kalenderwoche, in der die NAL abgerechnet wird",
  constructionSiteManagerEvaluationNalBillingCalendarWeekCurrent: "aktuell",
  constructionSiteManagerEvaluationConstructionSiteClosed: "Bst. geschl.",
  constructionSiteManagerEvaluationConstructionSiteClosedLong:
    "Baustelle in DATAflor abschließen",
  constructionSiteManagerEvaluationConstructionSiteClosedBlockedTooltip:
    "Baustelle kann erst abgeschlossen werden, wenn es keine offenen NAL und NZLA gibt.",
  constructionSiteManagerEvaluationFinalInvoiceLocked: "SR. Geschr.",
  constructionSiteManagerEvaluationFinalInvoiceLockedLong:
    "Schlussrechnung geschrieben",
  constructionSiteManagerEvaluationRevenueEffectiveCurrentYear:
    "Erlöswir. Abr. in {year}",
  constructionSiteManagerEvaluationRevenueEffectiveCurrentYearLong:
    "Erlöswirksame Abrechnung im aktuellen Jahr",
  constructionSiteManagerEvaluationComment: "Bemerkung",
  constructionSiteManagerEvaluationMarkedAsEvaluated: "Als bewertet markieren",
  constructionSiteManagerEvaluationMarkedAsEvaluatedBlockedTooltip:
    "Fülle alle Pflichtfelder, um die Baustelle als bewertet zu markieren.",
  nalShowMarkedAsEvaluatedToggleLabel:
    'Zeige als "Bewertet" markierte ({markedAsEvaluatedCount} / {totalCount})',
  nalMarkedAsEvaluatedTotalsLabel: 'Als "Bewertet" markiert',
  nalResizeColumnLabel: "Spaltenbreite ändern",
  nalTotalsLabel: "Gesamt",
  nalSortMenuLabelActualAscending: "Aufsteigend nach Ist-Zahlen",
  nalSortMenuLabelActualDescending: "Absteigend nach Ist-Zahlen",
  nalSortMenuLabelPlanAscending: "Aufsteigend nach Plan-Zahlen",
  nalSortMenuLabelPlanDescending: "Absteigend nach Plan-Zahlen",
  nalSortOutdatedTooltip:
    "Sortierung nicht mehr aktuell, weil Werte bearbeitet wurden. Klicken, um neu zu sortieren.",
  nalSortOutdatedButtonLabel: "Neu sortieren",
  nalSortMenuAbbreviationActual: "I",
  nalSortMenuAbbreviationPlan: "P",
  nalEmptyState:
    "Der gewählte Monat ist noch nicht für den NAL-Prozess eröffnet.",
  nalEntryDeadline: "Erfassungsfrist",
  nalReleaseDeadline: "Freigabefrist",
  nalStatusOpen: "Erfassungsphase",
  nalStatusEntryClosed: "Freigabephase",
  nalStatusReleaseOverdue: "Freigabe überfällig",
  nalOverviewTableHeaderTenant: "Mandant",
  nalOverviewTableHeaderEntryBySiteManagers: "Erfassung durch Bauleiter",
  nalOverviewTableHeaderReleaseByManager: "Freigabe durch GF",
  nalOverviewTableHeaderReleaseByControlling: "Freigabe durch Karin",
  nalOverviewTableHeaderActions: "Aktionen",
  nalOverviewOpenEntries: "Einträge anzeigen",
  nalOverviewOpenManagerView: "GF-Ansicht öffnen",
  nalOverviewFinalRelease: "Final freigeben",
  nalOverviewFinalReleaseDisabled: "Erst nach Freigabe durch GF möglich",
  nalFinalReleaseAction: "Freigabe",
  nalFinalReleaseActionDisabledTooltip:
    "Es liegen noch nicht alle Freigaben der GFs vor.",
  nalFinalReleaseActionTooltipIncomplete:
    "Fülle alle Pflichtfelder aus, damit der Monat final freigegeben werden kann.",
  nalFinalReleaseRevokeAction: "Freigabe zurückziehen",
  nalFinalReleaseRevokeDisabledTooltip:
    "Zurückziehen der Freigabe ist nicht mehr möglich, da der nächste Durchlauf gestartet hat.",
  nalFinalReleaseRevokeError:
    "Das Zurückziehen der Freigabe konnte nicht gespeichert werden.",
  nalExportAction: "Exportieren",
  nalExportDisabledTooltip: "Export erst nach Freigabe durch GF möglich",
  nalExportSuccess: "Export wird versendet.",
  nalExportError: "Export konnte nicht angestoßen werden.",
  nalEmptyResultTitle: "Nichts zu sehen",
  nalEmptyResultContent:
    "Für die aktuelle Auswahl gibt es keine NAL-Einträge – passe Periode oder Filter an.",
  nalEntriesTenantFilterLabel: "Mandant",
  nalConstructionSiteManagerFilterLabel: "Bauleiter",
  nalClientFilterLabel: "Auftraggeber",
  nalSearchLabel: "Suche",
  nalSearchPlaceholder: "Suche nach Baustellen-Nr., Bezeichnung, Auftraggeber",
  nalBackToOverview: "Zurück zur Übersicht",
  nalOpenInProjectsJournal: "Im Baubuch öffnen",
  nalOverviewTablePending: "ausstehend",
  nalOverviewTableReleasedOn: "am {date}",
  nalOverviewTableReleasedByTooltip: "Freigegeben von {name}",
  nalOverviewTableEntryDeadline: "bis zum {date}",
  nalOverviewTableReleaseDeadline: "bis zum {date}",
  nalOverviewTableSiteManagersCount: "{done} / {total} Bauleiter",
  nalPeriodName_1: "Januar",
  nalPeriodName_2: "Februar",
  nalPeriodName_3: "März",
  nalPeriodName_4: "April",
  nalPeriodName_5: "Mai",
  nalPeriodName_6: "Juni",
  nalPeriodName_7: "Juli",
  nalPeriodName_8: "August",
  nalPeriodName_9: "September",
  nalPeriodName_10: "Oktober",
  nalPeriodName_11: "November",
  nalPeriodName_12: "Dezember",
  nalPeriodName_13: "13. Lauf",
  nalPeriodThirteenthRunRangeLabel: "Jan - Dez",
  nalPeriodSelectPreviousYear: "Vorheriges Jahr",
  nalPeriodSelectNextYear: "Nächstes Jahr",
  nalPeriodSelectRunShortLabel: "{run}. Lauf",
  nalPeriodSelectRunLabel: "{run}. Lauf {year}",
  nalPeriodSelectPeriodLabel: "{periodName} {year} - {run}. Lauf",
  nalPeriodSelectStatusReleased: "Freigegeben",
  nalPeriodSelectStatusOpened: "Eröffnet",
  nalPeriodSelectStatusUpcoming: "Noch nicht eröffnet",
  nalPeriodSelectStatusLocked: "Gesperrt",
  nalPeriodSelectLabel: "Periode",
  constructionSiteManagerSave: "Speichern",
  constructionSiteManagerAllSaved: "Alles gespeichert",
  constructionSiteManagerAllSavedTooltip:
    "Änderungen wurden automatisch gespeichert",
  constructionSiteManagerEvaluationCostObject: "Baustelle",
  constructionSiteManagerEvaluationCostObjectLong: "Aktiver Kostenträger",
  constructionSiteManagerEvaluationManagers: "Bauleiter",
  constructionSiteManagerEvaluationManagersLong: "Bauleiter in DATAflor",
  constructionSiteManagerEvaluationMonthlyRevenue: "Geschr. Rechn.",
  constructionSiteManagerEvaluationMonthlyRevenueLong:
    "Erlöse, Erhaltene Anzahlung und Geschr. Abschlagsrechnung",
  constructionSiteManagerEvaluationMonthlyProductiveHours: "Prod.-STD.",
  constructionSiteManagerEvaluationMonthlyProductiveHoursLong:
    "Produktivstunden",
  constructionSiteManagerEvaluationMonthlyCosts: "Kosten",
  constructionSiteManagerEvaluationCumulativeProfitContribution: "DB (ABS.)",
  constructionSiteManagerEvaluationNalBasedProfitContribution: "DB (ABS.)",
  constructionSiteManagerEvaluationCumulativeRevenue: "Geschr. Rechn.",
  constructionSiteManagerEvaluationCumulativeRevenueLong:
    "Erlöse, Erhaltene Anzahlung und Geschr. Abschlagsrechnung",
  constructionSiteManagerEvaluationCumulativeCosts: "Kosten",
  constructionSiteManagerGroupPeriod: "{period} {year}",
  constructionSiteManagerGroupCumulative: "Kumuliert (bis {period} {year})",
  constructionSiteManagerGroupNal: "DB Kumuliert nach NAL",
  constructionSiteManagerEvaluationCustomer: "Auftraggeber",
  constructionSiteManagerEvaluationCustomerLong: "Auftraggeber in DATAflor",
  constructionSiteManagerEvaluationServiceCategory: "Lst.-Kategorie",
  constructionSiteManagerEvaluationServiceCategoryLong:
    "Leistungskategorie in DATAflor",
  constructionSiteManagerEvaluationProfitContributionLong:
    "Deckungsbeitrag Absolut",
  constructionSiteManagerEvaluationProfitContributionPercentageLong:
    "Deckungsbeitrag Relativ",
  constructionSiteManagerEvaluationProfitContributionPerHourLong:
    "Deckungsbeitrag pro Stunde",
  constructionSiteManagerEvaluationCumulativeProfitContributionPercentage:
    "DB (REL.)",
  constructionSiteManagerEvaluationCumulativeProfitContributionPerHour:
    "DB / STD.",
  constructionSiteManagerEvaluationNalBasedProfitContributionPercentage:
    "DB (REL.)",
  constructionSiteManagerEvaluationNalBasedProfitContributionPerHour:
    "DB / STD.",
  constructionSiteManagerEvaluationPeriodRangeJanuaryToDecember:
    "Jan - Dez {year}",
  nalClosePeriodButton: "Monat abschließen",
  nalClosePeriodButtonDone: "Monat abgeschlossen",
  nalClosePeriodTooltipDisabled:
    "Fülle alle Pflichtfelder aus, damit der Monat abgeschlossen werden kann.",
  nalClosePeriodTooltipFilterActive:
    "Bitte den Auftraggeber-Filter und die Suche zurücksetzen, um den Monat abzuschließen.",
  nalClosePeriodError: "Der Monatsabschluss konnte nicht gespeichert werden.",
  nalManagerStatusColumnHeader: "Status",
  nalManagerActionColumnHeader: "Aktion",
  nalManagerStatusClosed: "Abgeschlossen",
  nalManagerStatusPending: "Ausstehend",
  nalManagerCloseForCsmTooltip:
    "Mit Klick wird der Monat für den Bauleiter abgeschlossen",
  nalManagerCloseForCsmTooltipDisabled:
    "Fülle alle Pflichtfelder aus, damit der Monat abgeschlossen werden kann.",
  nalReleasePeriodAction: "Monat freigeben",
  nalReleasePeriodReleased: "Monat freigegeben",
  nalReleasePeriodTooltip: "Mit Klick wird der Monat final freigegeben.",
  nalReleasePeriodTooltipDisabled:
    "Zur Freigabe des Monats müssen alle Bauleiter den Monat abgeschlossen haben (Status: Abgeschlossen).",
  nalReleasePeriodTooltipIncomplete:
    "Fülle alle Pflichtfelder aus, damit der Monat freigegeben werden kann.",
  nalReleasePeriodError:
    "Die Freigabe des Monats konnte nicht gespeichert werden.",
  nalPreviousRunButtonLabel: "Vormonat übernehmen",
  nalPreviousRunTakeOverTooltip:
    "Klick hier, um die Eintragung aus dem Vormonat zu übernehmen.",
  nalPreviousRunNoValueTooltip: "Im Vormonat wurde nichts eingetragen.",
  nalPreviousValueLabel: "Vormonat:",
  nalValueHistoryButtonLabel: "Änderungshistorie",
  nalValueHistoryNoChange: "Es wurde keine Änderung vorgenommen.",
  nalValueHistoryYourValue: "Dein Wert",
  nalValueHistoryNewValueBy: "Neuer Wert von",
  nalValueHistoryPreviousValueBy: "Vorheriger Wert von",
  nalValueHistoryEmptyValue: "leer",
  nalValueHistoryUnknownPerson: "Unbekannt",
  monthlyControllingTableTotalUntilCurrentMonth:
    "Gesamt bis zum letzten abgeschlossenen Monat",
  monthlyControllingTableNoData: "Es liegen keine Daten vor.",
  monthlyControllingTableTotalUntilToday: "Kumuliert (01.01. - heute)",
  monthlyControllingTableTotal: "Gesamt {year}",
  monthlyControllingTablePreviousMonth: "Vorheriger Monat",
  monthlyControllingTableNextMonth: "Nächster Monat",
  surcharges: "Zuschlagssätze",
  surchargesDescription: "Zuschlagssätze bearbeiten",
  surchargesBreadcrumbs: "Zuschlagssätze",
  surchargesServiceCategoryDefault: "Default",
  surchargesUploadButton: "Datei hochladen",
  surchargesUploadSuccess: "Neue Zuschläge gespeichert",
  surchargesUploadFailed: "Fehler beim Speichern der Zuschläge",
  bookedHours: "Stunden aus der Lohnbuchhaltung",
  bookedHoursEmployeeFilterLabel: "Mitarbeitende",
  bookedHoursDescription: "Überblicke gebuchte Stunden deiner Mitarbeitenden",
  bookedHoursDateFilterLabel: "Buchungszeitraum",
  bookedHoursNothingToSeeTitle: "Keine Mitarbeitenden",
  bookedHoursNothingToSeeContent:
    "Dem ausgewählten Bauleitenden sind keine Mitarbeitenden zugeordnet.",
  bookedHoursTooltipBookedHoursLabel: "Stunden Lohnbuchhaltung",
  bookedHoursTooltipTrackedHoursLabel: "Stunden grewe-gruppe App",
  bookedHoursTooltipMaxWorkingHoursFullAge:
    "Maximale Tagesarbeitszeit von 10 Stunden überschritten",
  bookedHoursTooltipMaxWorkingHoursUnderage:
    "Maximale Tagesarbeitszeit von 8 Stunden für Minderjährige überschritten",
  bookedHoursTooltipMaxWeeklyWorkingHoursFullAge:
    "Maximale Wochenarbeitszeit von 48 Stunden überschritten",
  bookedHoursTooltipMaxWeeklyWorkingHoursUnderage:
    "Maximale Wochenarbeitszeit von 40 Stunden für Minderjährige überschritten",
  bookedHoursDifferenceBetweenTrackedAndBookedHours:
    "Abweichung zw. erfasster und gebuchter Arbeitszeit",
  bookedHoursMaxWorkingHoursExceededIconLabel:
    "Überschreitung der maximalen Arbeitszeit",
  bookedHoursOverheadCosts: "Gemeinkosten",
  bookedHoursResetFilterButtonLabel: "Filter zurücksetzen",
  employeeAdministration: "Mitarbeitendenverwaltung",
  employeeAdministrationDescription:
    "Übersicht und Verwaltung der Mitarbeitenden",
  employeeAdministrationSuperiorsFilterLabel: "Vorgesetzte/r",
  employeeAdministrationSuperiorsFilterPlaceholder: "Alle",
  employeeAdministrationJobTitlesFilterLabel: "Stellenbezeichnung",
  employeeAdministrationJobTitlesFilterPlaceholder: "Alle",
  employeeAdministrationSuperiorAssignmentMissingSingular:
    "Zuordnung ausstehend",
  employeeAdministrationSuperiorAssignmentMissingPlural:
    "Zuordnungen ausstehend",
  employeeAdministrationEditEmployeeNotPermittedTooltip:
    "Du bist nicht berechtigt Mitarbeitende zu bearbeiten. Bitte wende dich an die Geschäftsführung",
  employeeAdministrationExportPurchasingButtonLabel: "Export Einkauf",
  employeeAdministrationExportControllingButtonLabel: "Export Controlling",
  employeeAdministrationFilterTab_all: "Alle",
  employeeAdministrationFilterTab_ambiguousAddress: "Uneindeutige Adresse",
  employeeAdministrationAmbiguousAddresses: "Uneindeutige Adressen",
  employeeAdministrationAmbiguousAddress: "Uneindeutige Adresse",
  employeeListEmptyResult:
    "Für die ausgewählten Suchkriterien konnten keine Mitarbeitenden gefunden werden",
  employeeListNameLabel: "Name",
  employeeListJobTitleLabel: "Stellenbezeichnung",
  employeeListSuperiorLabel: "Vorgesetzte/r",
  employeeListResidenceAddressLabel: "Adresse",
  employeeListResidenceAddressStatusLabel: "Adress-Status",
  employeeListOfficeLocationLabel: "Standort",
  employeeListTeamsLabel: "Kolonnen",
  employeeListActionsLabel: "Aktionen",
  employeeListNoTeam: "keine",
  employeeListNoJobTitle: "Stellenbezeichnung nicht gesetzt",
  employeeListSuperiorMissing: "Zuordnung ausstehend",
  employeeListAddressStatusHigh: "✔ Eindeutig",
  employeeListAddressStatusManual: "Präzisiert",
  employeeListAddressStatusLow: "✗ Uneindeutig",
  employeeJobTitleManagement: "Geschäftsleiter:in",
  editEmployeeDialogTitle: "Mitarbeitenden bearbeiten",
  editEmployeeSuperiorLabel: "Vorgesetzte/r",
  editEmployeeSuperiorNoOptions: "Keine Vorgesetzte/r gefunden",
  editEmployeeSuccessFeedback: "Mitarbeiter/in wurde gespeichert",
  employeeValidationTeamsMustBelongToSameTenant:
    "Kolonnen müssen zum gleichen Mandanten gehören",
  employeeValidationSuperiorOfManagerMustBeAHoldingManager:
    "Vorgesetzte:r muss auch Geschäftsleiter:in sein",
  employeeValidationSuperiorOfNonManagerMustBeSameTenant:
    "Vorgesetzte/r muss zum gleichen Mandanten gehören",
  employeeValidationSuperiorCannotBeSelf:
    "Vorgesetzte/r darf nicht man selbst sein",
  employeeValidationSuperiorCannotBeCircular:
    "Vorgesetzte/r darf nicht zirkulär sein",
  toolMarkAllCheckboxLabel: "Alle Geräte auswählen",
  toolMarkCheckboxLabel: "{abbreviation} auswählen",
  toolMarkedCountSingular: "<b>{count} Gerät</b> ausgewählt",
  toolMarkedCountPlural: "<b>{count} Geräte</b> ausgewählt",
  toolClearMarked: "Zurücksetzen",
  toolTakeOverMarkedToolsAsFilter: "Als Filter übernehmen",
  toolExportNameplates: "Typenschilder exportieren",
  toolAbbreviationLabel: "Kürzel",
  toolAbbreviationPrefixLabel: "Kürzel-Präfix",
  toolAttachmentsLabel: "Anbauteile",
  toolBillableFromLabel: "Berechnet ab",
  toolCategoryLabel: "Kategorie",
  toolCommentLabel: "Bemerkung",
  toolConstructionYearLabel: "Baujahr",
  toolCostCenterLabel: "Kostenstelle",
  toolDailyRateLabel: "Tagessatz",
  toolDecommissionButton: "Stilllegen",
  toolDecommissionCommentLabel: "Kommentar zur Stilllegung",
  toolDecommissionReason: "Begründung",
  toolDecommissionReasonLabel: "Begründung der Stilllegung",
  toolDecommissionReason_inventory_shrinkage: "Inventurschwund",
  toolDecommissionReason_sale: "Verkauf",
  toolDecommissionReason_scrap: "Schrott",
  toolDecommissionReason_theft: "Diebstahl",
  toolDecommissionReason_unknown: "Unbekannt",
  toolDecommissionReason_return_after_leasing: "Rückgabe nach Leasing",
  toolDecommissionReason_long_term_rental_ended: "Dauermiete beendet",
  toolDecommissionReason_error: "Fehler",
  toolDecommissionedAtLabel: "Datum der Stilllegung",
  toolDecommissioning: "Stilllegung",
  toolDecommissioningModalCommentLabel: "Kommentar",
  toolDecommissioningModalSubmit: "Stilllegen",
  toolDecommissioningModalTitle: "Gerät endgültig stilllegen",
  toolDecommissioningScheduledSuccessToast:
    "Stilllegung für Gerät {abbr} erfolgreich terminiert.",
  toolDecommissioningSuccessToast:
    "Gerät {abbr} erfolgreich endgültig stillgelegt.",
  toolDetailsButton: "Details anzeigen",
  toolDuplicateButton: "Duplizieren",
  toolFilterAllTools: "Alle Geräte",
  toolFilterAllToolsDescription: "Hier findest du alle Geräte aller Standorte.",
  toolFilterManagersLabel: "Manager",
  toolFilterMyResponsibilities: "Ich",
  toolFilterMyTools: "Meine Geräte",
  toolFilterMyToolsDescription:
    "Hier findest du alle Geräte, die du übernommen hast.",
  toolFilterAssignedTools: "Für dich vorgemerkte Geräte",
  toolFilterAssignedToolsDescription:
    "Hier findest du alle Geräte, die für dich von deinem Manager vorgemerkt wurden.",
  toolFilterTenantsLabel: "Mandanten",
  toolFilterWithoutResponsibleEmployee: "Niemand",
  toolFinancingToLabel: "Finanzierung bis",
  toolFinancingTypeLabel: "Finanzierungsstatus",
  toolFormAbbreviationConflict:
    "Dieses Kürzel ist bereits vergeben oder das Schema ist inkorrekt.",
  toolFormBasicInfoHeadline: "Grunddaten",
  toolFormBothOrNoneError:
    "Bitte beide Felder ausfüllen oder beide leer lassen",
  toolFormConstructionYearError: "Bitte ein gültiges Baujahr eingeben",
  toolFormCoreDataTitle: "Stammdaten",
  toolFormEditHeadline: "{name} bearbeiten",
  toolFormMiscDataTitle: "Sonstige Daten",
  toolNameLabel: "Bezeichnung",
  toolNameplateSizeLabel: "Typenschild-Format",
  toolNameplateSize_tiny: "Mini (25,4 mm x 12,7 mm)",
  toolNameplateSize_small: "Klein (76,2 mm x 25,4 mm)",
  toolNameplateSize_large: "Groß (100 mm x 150 mm)",
  toolNameplateFormat_tiny: "Mini",
  toolNameplateFormat_small: "Klein",
  toolNameplateFormat_large: "Groß",
  toolNameplateInfoToggleTitle: "Mehr über Formate",
  toolFormPurchaseDataTitle: "Kaufdaten",
  toolFormSerialNumberDuplicateError:
    "Die Seriennummer {serialNumber} existiert bereits in den Geräten {tools}. Bist du sicher, dass du diese verwenden möchtest?",
  toolFormToolIdConflict: "Diese Geräte-ID ist bereits vergeben.",
  toolHistoryButton: "Historie anzeigen",
  toolHistoryChangesNo: "Nein",
  toolHistoryChangesYes: "Ja",
  toolHistoryDescriptionAvailability: "Verfügbarkeit",
  toolHistoryModalTableHeaderDate: "Am",
  toolHistoryModalTableHeaderDescription: "Beschreibung",
  toolHistoryModalTableHeaderModifiedBy: "Geändert durch",
  toolHistoryModalTableHeaderTime: "Um",
  toolHistoryModalTableHeaderEventGroup: "Vorgangstyp",
  toolHistoryModalTableHeaderType: "Vorgang",
  toolHistoryModalDateRangeLabel: "Zeitraum",
  toolHistoryModalTitle: "Gerätehistorie",
  toolHistoryToolWasCreated: "Das Gerät wurde erstellt",
  toolHistoryToolDocumentWasCreated: `Das Dokument <strong>"{placeholder}"</strong> wurde hochgeladen`,
  toolHistoryToolDocumentWasDeleted: `Das Dokument <strong>"{placeholder}"</strong> wurde gelöscht`,
  toolHistoryInventoryCreated: "Das Gerät wurde inventarisiert",
  toolHistoryInventoryUpdated: "Die Inventarisierung wurde bearbeitet",
  toolHistoryInventoryDeleted: "Die Inventarisierung wurde gelöscht",
  toolHistoryInventoryMovedFrom: "Die Inventarisierung wurde eingefügt",
  toolHistoryInventoryMovedTo: "Die Inventarisierung wurde verschoben",
  toolHistoryTypeChipCreated: "Erstellt",
  toolHistoryAutoUploadedDocument: "Automatischer Upload",
  toolResponsibilityReturned: "Zurückgegeben",
  toolResponsibilityTaken: "Übernommen",
  toolResponsibilityAssigned: "Vorgemerkt",
  toolMadeAvailable: "Verfügbar gemacht",
  toolResponsibilityRejected: "Abgelehnt",
  toolInventoryCreated: "Erstellt",
  toolInventoryUpdated: "Bearbeitet",
  toolInventoryDeleted: "Gelöscht",
  toolInventoryMovedTo: "Verschoben",
  toolInventoryMovedFrom: "Eingefügt",
  toolInventoryPhotoGalleryTitle: "Bilder von {toolName}",
  toolPermanentDecommissioned: "Stillgelegt",
  toolPermanentRecommissioned: "Reaktiviert",
  toolDocumentCreated: "Dokument hochgeladen",
  toolDocumentDeleted: "Dokument gelöscht",
  toolHistoryTypeChipUpdated: "Geändert",
  toolHistoryValueChangedFrom: 'geändert von "{old}" zu ---',
  toolHistoryValueChangedFromTo: 'geändert von "{old}" zu "{new}"',
  toolHistoryValueChangedTo: 'geändert zu "{new}"',
  toolHistoryValueChangedTo_assign:
    'geändert zu <b>"vorgemerkt"<b> für {newValue}',
  toolHistoryValueChangedTo_available: 'geändert zu <b>"verfügbar"<b>',
  toolHistoryValueChangedTo_take: 'geändert zu <b>"vergeben"<b>',
  toolHistoryValueChangedTo_return: 'geändert zu <b>"verfügbar"<b>',
  toolHistoryValueChangedTo_reject: 'geändert zu <b>"verfügbar"<b>',
  toolHistoryValueChangedTo_make_available: 'geändert zu <b>"verfügbar"<b>',
  toolHistoryEventGroup_tool: "Gerät",
  toolHistoryEventGroup_responsibility: "Verantwortlichkeit",
  toolHistoryEventGroup_documents: "Dokumente",
  toolHistoryEventGroup_inventory: "Inventarisierung",
  toolHistoryNoResultsWithFilters:
    "Für die ausgewählten Suchkriterien konnte kein Eintrag gefunden werden.",
  toolIdLabel: "ID",
  toolInsuranceLineLabel: "Versicherungssparte",
  toolInsuranceToolTypeLabel: "Fahrzeug- / Anlagenart für Versicherung",
  toolInsuranceTypeLabel: "versicherter Tarif",
  toolIsBillableLabel: "Leistungsgerät",
  toolIsNotBillableLabel: "Gemeinkostengerät",
  toolLicensePlateNumberLabel: "Kfz-Kennzeichen",
  toolListActionsLabel: "Aktionen",
  toolListIsBillable: "Leistung",
  toolListIsNotBillable: "Gemeinkosten",
  toolListPreviousResponsibleEmployee: "Zuletzt",
  toolListSerialNumber: "SN:",
  toolListTenantLabel: "Mandant",
  toolListToolId: "ID",
  toolListTypeLabel: "Geräteart",
  toolManagement: "Geräteverwaltung",
  toolManagementDescription: "Verantworte deine Geräte.",
  toolManagerLabel: "Manager/in",
  toolManufacturerLabel: "Hersteller",
  toolMinuteRateLabel: "Minutensatz",
  toolOperatingHoursLabel: "Anzahl Betriebsstunden",
  toolPowerLabel: "Leistung",
  toolPurchaseDateLabel: "Kaufdatum",
  toolPurchasePriceLabel: "Anschaffungspreis (netto)",
  toolQueryOperatingHoursLabel: "Abfrage Betriebsstunden",
  toolRecommissionButton: "Reaktivieren",
  toolRecommissioningModalSubmit: "Reaktivieren",
  toolRecommissioningModalTitle: "Gerät reaktivieren",
  toolRecommissioningSuccessToast: "Gerät {abbr} erfolgreich reaktiviert.",
  toolResponsibleEmployeeLabel: "Verantwortliche/r",
  toolResponsibilityStateLabel: "Verfügbarkeit",
  toolResponsibilityStateOptionAvailable: "Verfügbar",
  toolResponsibilityStateOptionAssigned: "Vorgemerkt",
  toolResponsibilityStateOptionTaken: "Vergeben",
  toolResponsibleEmployeeAssignedLabel: "Vorgemerkte/r Mitarbeitende/r",
  toolResponsibleEmployeeColumnLabel: "Buchung / Verantwortlichkeit",
  toolReturnResponsibility: "Zurückgeben",
  toolReturnResponsibilitySuccess: "Gerät {abbr} zurückgegeben.",
  toolRejectResponsibilitySuccess: "Gerät {abbr} abgelehnt.",
  toolMakeAvailableResponsibilitySuccess: "Gerät {abbr} verfügbar gemacht.",
  toolAssignOfflineHint:
    "Vormerken und Verfügbar machen sind offline nicht möglich.",
  toolSerialNumberLabel: "Seriennummer",
  toolSizeLabel: "Größe",
  toolSupplierLabel: "Lieferant (extern)",
  toolTakeAndReturnResponsibilityHint:
    "Wird bei Zeitbuchungen automatisch übernommen o. zurückgegeben.",
  toolTakeResponsibility: "Übernehmen",
  toolAcceptResponsibility: "Annehmen",
  toolRejectResponsibility: "Ablehnen",
  toolTakeResponsibilitySuccess: "Gerät {abbr} übernommen.",
  toolTemporarilyDecommissionedFromLabel: "Saisonal stillgelegt von",
  toolTemporarilyDecommissionedToLabel: "Saisonal stillgelegt bis",
  toolTenantLabel: "Mandant",
  toolToolIdLabel: "Geräte-ID",
  toolToolTypeLabel: "Geräteart",
  toolTypeDesignationLabel: "Typenbezeichnung",
  toolsAndDevices: "Maschinen & Geräte",
  toolsResponsibilityDisplayPrevious: "Davor",
  toolsResponsibilityDisplayCurrent: "Aktuell",
  toolsResponsibilityDisplayNoDate: "kein Datum",
  exportTools: "Geräteliste exportieren",
  exportInventory: "Inventuransicht exportieren",
  exportToolAccountingRecords: "Gerätestunden exportieren",
  errorExportingTools:
    "Beim Exportieren der Geräteliste ist etwas schiefgelaufen. Bitte versuche es später erneut.",
  errorExportingInventory:
    "Beim Exportieren der Inventuransicht ist etwas schiefgelaufen. Bitte versuche es später erneut.",
  errorExportingToolAccountingRecords:
    "Beim Exportieren der Gerätestunden ist etwas schiefgelaufen. Bitte versuche es später erneut.",
  addTool: "Gerät anlegen",
  addToolSuccess: "Gerät {abbr} erfolgreich hinzugefügt",
  editToolSuccess: "Gerät {abbr} erfolgreich bearbeitet",
  teamAdministration: "Kolonnenverwaltung",
  teamAdministrationDescription: "Verwalte die Mitarbeitenden deiner Kolonnen.",
  monitoring: "Monitoring",
  monitoringDescription: "Beobachte aktive Zeitbuchungen.",
  timesAndTools: "Meine Zeiten und Geräte",
  tasks: "Meine Aufgaben",
  tasksEmpty: "So weit alles sauber. Weitermachen!",
  tasksTimeApprovalLink: "Zur Zeitenfreigabe",
  tasksTimeApprovalTitleHtml: `
    <strong>Zeitenbuchungen</strong> warten auf deine <strong>Freigabe</strong>
  `,
  tasksEmployeeAdministrationLink: "Zur Mitarbeitendenverwaltung",
  tasksEmployeeAdministrationMissingSuperiorsTitleHtml: `
    <strong>Mitarbeitende</strong> wollen <strong>Vorgesetzte</strong>
  `,
  tasksEmployeeAdministrationAmbiguousAddressesTitleHtml: `
    <strong>Privatadressen</strong> müssen <strong>präzisiert</strong> werden
  `,
  tasksToolAdministrationLink: "Zur Geräteverwaltung",
  tasksToolAdministrationTitleHtml: `
    <strong>Geräte</strong> wollen <strong>übernommen</strong> werden
  `,
  tasksUploadQueueBadgeText: "Upload-Warteschlange",
  tasksUploadQueueTitleHtml: `
    <strong>Upload Foto-Dokumentation</strong> ist <strong>fehlgeschlagen</strong>
  `,
  tasksUploadQueueLink: "Zur Foto-Dokumentation",
  tasksPhotoDocAssignmentTitleHtml: `
    <strong>Fotos</strong> wollen <strong>zugeordnet werden</strong>
  `,
  tasksPhotoDocAssignmentBadgeText: "Zuordnung ausstehend",
  tasksPhotoDocAssignmentLink: "Zur Foto-Dokumentation",
  takePhoto: "Foto aufnehmen",
  timeTracking: "Zeiterfassung",
  timeTrackingDescription: "Erfasse deine Arbeitszeiten.",
  appName: "grewe-gruppe App",
  startPage: "Startseite",
  breadcrumb: "Breadcrumb",
  maintenance: "Instandhaltung",
  assignments: "Aufträge",
  workload: "Auslastung",
  columnView: "Spalten",
  listView: "Liste",
  add: "Hinzufügen",
  remove: "Entfernen",
  discard: "Verwerfen",
  edit: "Bearbeiten",
  save: "Speichern",
  saveAndContinue: "Speichern & weiter",
  cancel: "Abbrechen",
  back: "Zurück",
  saved: "Gespeichert",
  team: "Kolonne",
  noTeamAssignment: "Keine Kolonnenplanung...",
  teamAssignmentCollapseAll: "Alle einklappen",
  teamAssignmentExpandAll: "Alle ausklappen",
  teamAssignmentHeadingNewPlaceholder: "Neue Kolonnenplanung",
  teamAssignmentHeadingTeamPlaceholder: "Bitte Kolonne wählen...",
  teamAssignmentHeadingWorkPackagePlaceholder:
    "Bitte Arbeitspaket und Zeitraum wählen...",
  teamAssignmentHeadingCopyLabel:
    "Zum Kopieren von Planung und / oder Arbeitspaket klicken",
  teamAssignmentCopyAssignment: "Planung (Kolonne und Zeitraum) duplizieren",
  teamAssignmentCopyWorkPackage: "Arbeitspaket duplizieren",
  teamAssignmentCopyAssignmentAndWorkPackage:
    "Planung und Arbeitspaket duplizieren",
  teamAssignmentHeadingDeleteLabel: "Planung entfernen",
  teamAssignmentHeadingSerialDateLabel: "Serienplanung erstellen",
  createPreparationAssignmentLabel:
    "Planung mit Arbeitspaket für Lade- und Rüstzeit erstellen",
  createPreparationAssignmentSuccess:
    "Planung mit Arbeitspaket für Lade- und Rüstzeit erfolgreich erstellt",
  createPreparationAssignmentNotAllowedError:
    "Es kann keine Planung für Lade- und Rüstzeit für ein Lade- und Rüstzeit-Arbeitspaket erstellt werden.",
  deleteTeamAssignmentSuccess: "Planung erfolgreich gelöscht",
  deleteTeamAssignmentError: "Fehler beim Löschen der Planung",
  teamAssignmentSerialDateDialogTitle: "Serienplanung erstellen",
  teamAssignmentSerialDateDialogDateRangeLabel: "Aus Zeitraum",
  teamAssignmentSerialDateDialogrepetitionIntervalLabel: "Wiederholen alle",
  teamAssignmentSerialDateDialogRepetitionWeekdaysLabel: "Wiederholen am",
  teamAssignmentSerialDateDialogEndHeader: "Ende",
  teamAssignmentSerialDateDialogEndOnYearEndRadioLabel: "Zum Jahresende",
  teamAssignmentSerialDateDialogEndOnDateRadioLabel: "Am",
  teamAssignmentSerialDateDialogEndAfterNumberOfDatesRadioLabel: "Nach",
  teamAssignmentSerialDateDialogEndAfterNumberOfDatesLabelSingular:
    "Wiederholung",
  teamAssignmentSerialDateDialogEndAfterNumberOfDatesLabelPlural:
    "Wiederholungen",
  teamAssignmentSerialDateDialogDoneButtonLabel: "Fertig",
  teamAssignmentSerialDateDialogWithPreparation: "mit Lade- und Rüstzeit",
  teamAssignmentSerialDateDialogMonthyTypeOptionDate: "Monatlich am {date}.",
  teamAssignmentSerialDateDialogMonthyTypeOptionDay:
    "Monatlich am {weekNumber}. {weekday}",
  teamAssignmentSerialDateDialogMonthyTypeOptionDayLastWeek:
    "Monatlich am letzten {weekday}",
  teamAssignmentSerialDateDialogEndOnDateMustBeAfterStartDateError:
    "Datum muss nach dem Startdatum des Zeitraums liegen",
  teamAssignmentSerialDateDialogSuccessToast:
    "Es wurden {count} Planungen angelegt.",
  teamAssignmentSerialDateDialogErrorToast:
    "Erstellung abgebrochen, da zu viele Planungen (mehr als {count}) erstellt werden würden.",
  coreTeam: "Kolonne",
  selectCoreTeam: "Kolonne wählen...",
  noCoreTeam: "Keine Kolonne gewählt...",
  additionalResources: "Zusätzliche Mitarbeiter o. Geräte",
  selectAdditionalResources: "Mitarbeiter o. Geräte suchen...",
  additionalEmployees: "Zusätzliche Mitarbeiter",
  selectAdditionalEmployees: "Mitarbeiter suchen...",
  saveTeam: "Kolonne speichern",
  manageTeam: "Kolonnenverwaltung",
  searchTeams: "Suche Kolonnen",
  teamPersonOrTool: "Kolonne, Person o. Gerät",
  workPackage: "Arbeitspaket",
  workPackageAdministration: "Arbeitspakete",
  workPackageAdministrationDescription: "Verwalte deine Arbeitspakete.",
  workPackageAdministrationColumnsWorkPackage: "Arbeitspaket",
  workPackageAdministrationColumnsManager: "Bauleiter",
  workPackageAdministrationColumnsServiceCategory: "Leistungskategorie",
  workPackageAdministrationColumnsWageType: "Lohnart",
  workPackageAdministrationColumnsLocation: "Ausführungsort",
  workPackageAdministrationColumnsNote: "Hinweis z. Ausf. an Kolonne",
  workPackageAdministrationColumnsHours: "Std. Ist / Plan",
  workPackageAdministrationColumnsActions: "Aktionen",
  workPackageAdministrationConstructionSiteLink: "Zur Baustelle",
  workPackageAdministrationSearchPlaceholder:
    "Baustelle oder Arbeitspaket suchen...",
  workPackageAdministrationTabAll: "Alle ({count})",
  workPackageAdministrationTabInvalid: "Fehlerhafte ({count})",
  workPackageAdministrationNoTeamAssignments:
    "Noch keine Planungen in diesem Arbeitspaket.",
  workPackageLocationDisabledAndInvalid:
    "Das Arbeitspaket kann nicht gespeichert werden, da der Ausführungsort ungültig ist und nicht mehr geändert werden kann.",
  workPackageAccountingFieldsUnchangeableInfo:
    "Einige Felder können nicht verändert werden, da es bereits Zeitbuchungen für das Arbeitspaket gibt.",
  workPackageChargeableHoursOnlyFieldsDisabledInfo:
    "Einige Felder werden für die gewählte Lohnart nicht benötigt und sind daher nicht bearbeitbar.",
  workPackageValidationAccountingFieldsCannotBeModified:
    "Dieses Feld kann nicht verändert werden, da es bereits Zeitbuchungen für das Arbeitspaket gibt",
  workPackageValidationCommuteExpensesOnlyWithChargeableHours:
    "Wegegeld kann nur für Produktivstunden aktiviert werden",
  selectWorkPackage: "Arbeitspaket wählen",
  noWorkPackage: "Kein Arbeitspaket gewählt...",
  noWorkPackageHelperText:
    "Du musst ein Arbeitspaket wählen oder neu anlegen...",
  addWorkPackage: "Neues Arbeitspaket",
  addWorkPackageFromTextbox: "Neues Arbeitspaket {workPackage} anlegen",
  addWorkPackageSuccess: "Arbeitspaket erfolgreich erstellt",
  editWorkPackage: "Arbeitspaket bearbeiten",
  copyWorkPackage: "Arbeitspaket kopieren",
  editWorkPackageCopyClientAddressTooltip:
    "Zum Kopieren der Auftraggeber-Adresse klicken.",
  editingWorkPackageCopyClientAddressSuccessToast:
    "Die Auftraggeber-Adresse wurde in die Zwischenablage kopiert.",
  workHoursPerDay: "Arbeitsstunden / Tag",
  numDays: "Anzahl Tage",
  from: "von",
  to: "bis",
  on: "am",
  dateRange: "Zeitraum",
  addTeamAssignmentBuilder: "Kolonnenplanung hinzufügen",
  invalidValue: "Ungültiger Wert",
  invalidDate: "Ungültiges Datum.",
  invalidDateRange: "Start-Datum muss vor End-Datum liegen",
  invalidDateWithoutYear: "Ungültiges Datum. Bitte nutze das Format TT.MM.",
  invalidLicensePlateNumber: "Das Kennzeichen ist ungültig.",
  invalidLocation: "Die Adresse ist ungültig.",
  dateInPast: "Datum darf nicht in der Vergangenheit liegen.",
  dateInFuture: "Datum darf nicht in der Zukunft liegen.",
  numberBetween: "Bitte gib eine gültige Zahl ein.",
  required: "Pflichtfeld",
  optional: "optional",
  maxLength: "Maximale Länge: %{maxLength} Zeichen",
  noOptions: "Keine Einträge gefunden",
  trackingCurrent: "Heute geplante Arbeitspakete",
  constructionSiteManager: "Bauleiter",
  managerSelectAllOption: "Alle",
  timeEntryStatusOpen: "Offen",
  timeEntryStatusManagerAccount: "Bauleiterkonto",
  timeEntryStatusApproved: "Freigegeben",
  timeEntryStatusExported: "Gebucht",
  timeEntryStatusDeleted: "Gelöscht",
  timeEntryStatusConflict: "Konflikt",
  timeEntryStatusConflicts: "Konflikte",
  timeEntryCommuteAnomaly: "Auffällige Zeit für Wegegeld",
  timeEntryCommuteAnomalies: "Auffällige Zeiten für Wegegeld",
  constructionSiteListUnplanned: "Ungeplant",
  constructionSiteListUnplannedFortnight:
    "(Start innerhalb der nächsten 14 Tage oder geplanter Baubeginn überschritten)",
  constructionSiteListPlanned: "Geplant",
  constructionSiteListDone: "Abgeschlossen",
  constructionSiteListInProgress: "In Bearbeitung",
  constructionSiteListUnplannedWarning: "Geplanter Baubeginn unbekannt",
  trackingAlreadyStoppedTitle: "Buchung bereits beendet",
  trackingAlreadyStoppedDescription:
    "Deine Buchung wurde bereits beendet. Dies kann z. B. durch den Bauleiter geschehen.",
  trackingAlreadyStoppedButton: "Verstanden & Weiter",
  trackingConstructionSiteManager: "Mein Bauleiter",
  trackingConstructionSiteManagerAccount: "Bauleiterkonto",
  trackingConstructionSiteManagerAccountInfo:
    "Erfasse deine Zeiten auf dieses Bauleiterkonto, wenn noch kein Arbeitspaket für deine Baustelle existiert.",
  trackingConstructionSiteManagerDialogTitle: "Auftrag erfassen",
  trackingConstructionSiteManagerFormCustomerName:
    "Kundenname / Ansprechpartner",
  trackingConstructionSiteManagerFormManagerName: "Bauleiter",
  trackingConstructionSiteManagerFormStreet: "Straße",
  trackingConstructionSiteManagerFormHouseNumber: "Haus-Nr.",
  trackingConstructionSiteManagerFormZip: "PLZ",
  trackingConstructionSiteManagerFormCity: "Ort",
  trackingConstructionSiteManagerFormPhone: "Telefonnummer",
  trackingConstructionSiteManagerFormDescription:
    "Kundenauftrag / Beschreibung der Baustelle",
  trackingConstructionSiteManagerTeamName: "Buchung auf Bauleiterkonto",
  trackingSummaryModalTitle: "Zusammenfassung",
  trackingTimeEntrySummaryModalTitle: "Erfasste Zeiten",
  trackingTimeEntrySummaryTableNet: "Netto",
  trackingSummaryModalPerformedActivities: "Durchgeführte Tätigkeiten",
  trackingSummaryModalNote: "Notiz",
  trackingSummaryModalContinueButton: "Zurück",
  trackingSummaryModalStopButton: "Beenden",
  trackingSplitModalTitle: "Zeitbuchung aufteilen",
  trackingSplitModalDescription: `Deine Zeitbuchung hat Mitternacht überschritten. Aus technischen Gründen
  muss deine laufende Zeitbuchung in zwei tagesbezogene Buchungen
  aufgeteilt werden.
    <br />
    Deine laufende Buchung zählt die Zeit seit 00:00 Uhr, deine gestrigen
  Zeiten bis 23:59 Uhr sind wie folgt zusammengefasst:`,
  trackingAutoStopSuccessToast:
    "Buchung wurde automatisch beendet. Buchungen werden nach 16 Stunden automatisch beendet.",
  trackingSplitModalConfirm: "Weitermachen!",
  trackingForceStopModalTitle: "Zeitbuchung stoppen",
  trackingForceStopModalDescription: `Die Buchungen werden gestoppt und die Laufzeit auf 0 Sekunden gesetzt.
  Weitere Anpassungen der Buchung kannst du nach Beendigung im Bereich Zeitenfreigabe vornehmen.`,
  trackingForceStopModalConfirm: "Zeitbuchung stoppen",
  trackingSwitchWorkPackageDialogTitle: "Arbeitspaket wechseln",
  trackingSwitchWorkPackageDialogContent:
    "Bei Bestätigen werden alle zusätzlichen Mitarbeitenden und Geräte aus der aktuellen Zeitbuchung ausgebucht.",
  trackingEditArrival: "Hinweg ändern",
  trackingSwitchWorkPackageDialogConfirmButton: "Bestätigen",
  trackingSwitchToManagerAccountDialogTitle: "Auf Bauleiterkonto wechseln",
  trackingSwitchToManagerAccountDialogContent:
    "Bei Bestätigen wird die aktuelle Zeitbuchung beendet. Alle Mitarbeitenden und Geräte werden auf die Bauleiterkonto-Buchung gebucht.",
  trackingSwitchNotPossibleError:
    "Ein direkter Wechsel der Zeiterfassung ist leider nicht möglich. Bitte stoppe zuerst die laufende Zeiterfassung.",
  trackingOverviewTrainingTitle: "Weiterbildung",
  trackingOverviewTrainingInfo: "Hier klicken, um Weiterbildung einzutragen",
  trackingTrainingBannerTitle: "Weiterbildung",
  trackingUnknownBannerTitle: "Unbekannte Aufgabe",
  trackingTrainingParticipants: "Teilnehmende",
  trackingTrainingModalTitle: "Weiterbildungsdetails erfassen",
  trackingTrainingFormApprovalBy: "Freizugeben von",
  trackingTrainingFormNote: "Bemerkung",
  dailySummaryBreadcrumbsHeader: "Heutige Buchungen",
  dailySummaryTableHeading: "Gesamt",
  dailySummaryTableName: "Name",
  dailySummaryTableTime: "Zeit",
  dailySummaryTableBreak: "Pause",
  dailySummaryTableNet: "Netto",
  dailySummaryTableError:
    "Zeitenzusammenfassung kann nicht angezeigt werden, da es Fehler in den Zeiten gibt.",
  dailySummaryTableNoTimeTrackings:
    "Du hast heute noch keine Buchungen abgeschlossen.",
  dailySummaryAccordionEntriesFrom: "Buchungen von",
  dailySummaryBack: "Zurück",
  trackingRecent: "Zuletzt benutzt",
  startTimeTracking: "Zeiterfassung starten",
  startTimeTrackingSuccess: "Zeiterfassung gestartet",
  splitTrackingSuccess:
    "Deine Zeiterfassung wurde geteilt. Wir zeigen dir jetzt die Dauer ab der Teilung an. Keine Sorge, deine bisherige Buchung ist sicher.",
  stopTimeTracking: "Stoppen",
  stopTimeTrackingSuccess: "Zeiterfassung gestoppt",
  timeTrackingCommuteDialogStartTitle: "Hinweg bestimmen",
  timeTrackingCommuteDialogStartStepOneTitle: "Woher kommt ihr heute?",
  timeTrackingCommuteDialogStartStepTwoTitle: "Wer ist gefahren?",
  timeTrackingCommuteDialogStartLocationTitle: "Abfahrtsort",
  timeTrackingCommuteDialogStopTitle: "Rückweg bestimmen",
  timeTrackingCommuteDialogStopStepOneTitle: "Rückweg wohin?",
  timeTrackingCommuteDialogStopStepTwoTitle: "Wer fährt zurück?",
  timeTrackingCommuteDialogStopLocationTitle: "Ziel",
  timeTrackingCommuteDialogStepCounter: "Schritt {current} von {total}",
  timeTrackingCommuteDialogHomeIconTitle: "Zuhause",
  timeTrackingCommuteDialogSiteIconTitle: "Betriebshof",
  timeTrackingCommuteDialogNoCommuteIconTitle: "Kein Wegegeld",
  timeTrackingCommuteDialogDriverIconTitle: "Fahrer/in",
  timeTrackingCommuteDialogNextButton: "Weiter",
  timeTrackingCommuteDialogBackButton: "Zurück",
  timeTrackingCommuteDialogCancelButton: "Abbrechen",
  timeTrackingCommuteDialogStartTrackingButton: "Fertig",
  timeTrackingCommuteDialogStopTrackingButton: "Beenden",
  timeTrackingQuickCheckInCheckOutButtonLabel_arrival_no_commute:
    "Kein Wegegeld",
  timeTrackingQuickCheckInCheckOutButtonLabel_arrival_driver_home:
    "<b>Von Zuhause</b> als <b>Fahrer/in</b>",
  timeTrackingQuickCheckInCheckOutButtonLabel_arrival_driver_site:
    "<b>Vom Betriebshof</b> als <b>Fahrer/in</b>",
  timeTrackingQuickCheckInCheckOutButtonLabel_arrival_passenger_home:
    "<b>Von Zuhause</b> als <b>Beifahrer/in</b>",
  timeTrackingQuickCheckInCheckOutButtonLabel_arrival_passenger_site:
    "<b>Vom Betriebshof</b> als <b>Beifahrer/in</b>",
  timeTrackingQuickCheckInCheckOutButtonLabel_departure_no_commute:
    "Kein Wegegeld",
  timeTrackingQuickCheckInCheckOutButtonLabel_departure_driver_home:
    "<b>Nach Hause</b> als <b>Fahrer/in</b>",
  timeTrackingQuickCheckInCheckOutButtonLabel_departure_driver_site:
    "<b>Zum Betriebshof</b> als <b>Fahrer/in</b>",
  timeTrackingQuickCheckInCheckOutButtonLabel_departure_passenger_home:
    "<b>Nach Hause</b> als <b>Beifahrer/in</b>",
  timeTrackingQuickCheckInCheckOutButtonLabel_departure_passenger_site:
    "<b>Zum Betriebshof</b> als <b>Beifahrer/in</b>",
  timeTrackingCommuteTypeLabel_no_commute: "Kein Wegegeld",
  timeTrackingCommuteTypeLabel_driver_home: "Zuhause / Fahrer/in",
  timeTrackingCommuteTypeLabel_driver_site: "Betriebshof / Fahrer/in",
  timeTrackingCommuteTypeLabel_passenger_home: "Zuhause / Beifahrer/in",
  timeTrackingCommuteTypeLabel_passenger_site: "Betriebshof / Beifahrer/in",
  timeTrackingSince: "seit",
  timeTrackingToolDetails: "Gerätedetails",
  addResource: "{resource} hinzufügen",
  editResource: "{resource} bearbeiten",
  removeResource: "{resource} entfernen",
  open: "Öffnen",
  close: "Schließen",
  clear: "Zurücksetzen",
  signIn: "Mit Microsoft anmelden",
  signOut: "Abmelden",
  loginFailed:
    "Bei der Anmeldung ist etwas schiefgelaufen. Bitte versuche es erneut.",
  logoutFailed:
    "Bei der Abmeldung ist etwas schiefgelaufen. Bitte versuche es erneut.",
  syncButtonTooltip: "Daten der App synchronisieren",
  syncButtonConstructionSitesTooltip: "Baustellen-Daten synchronisieren",
  syncButtonEmployeesTooltip: "Mitarbeitenden-Daten synchronisieren",
  syncButtonControllingDataTooltip: "Controlling-Daten synchronisieren",
  syncButtonAppDataTooltip: "App-Daten synchronisieren",
  syncMenuTitle: "Synchronisations-Status",
  syncMenuEmployeesTitle: "Mitarbeitenden-Daten",
  syncMenuConstructionSitesTitle: "Baustellen-Daten",
  syncMenuControllingTitle: "Controlling-Daten",
  syncMenuAppDataTitle: "App-Daten",
  syncMenuEmployeesDescription:
    "Aktualisiert: Mitarbeitendenverwaltung, Organigramm.",
  syncMenuConstructionSitesDescription: "Aktualisiert: Baustellenplanung.",
  syncMenuControllingDescription:
    "Aktualisiert: Baubuch, Lohnarten, Sachkonten, Stunden aus der Lohnbuchhaltung, Stundenauswertung, Deckungsbeitrags-Report, Abrechnungs-Report.",
  syncMenuAppDataDescription:
    "Setzt den App-Cache zurück und lädt alle angezeigten Daten neu.",
  syncMenuSyncNowTooltip: "Jetzt synchronisieren",
  syncMenuInfoButtonAriaLabel: "Details zu {title} anzeigen",
  syncMenuLastSyncedAt: "Zuletzt synchronisiert:",
  syncMenuLastSyncUnknown: "Synchronisations-Status unbekannt",
  syncMenuMaxTimeInformation: "Dauert bis zu {maxTime} min...",
  syncMenuSyncRunning: "Synchronisation im Gange",
  syncMenuSyncFailed: "Letzte Synchronisation fehlgeschlagen",
  syncMenuFooter: "Bei Fehlern wende Dich bitte per Mail an",
  syncRefetchSuccess: "Synchronisierung abgeschlossen",
  notFoundHeader: "Seite nicht gefunden",
  notFoundText: "Diese Seite konnte nicht gefunden werden.",
  genericErrorPageHeader: "Ein Fehler ist aufgetreten",
  genericErrorPageText:
    "Bitte lade die Seite neu. Wir haben bereits eine Fehlermeldung im Hintergrund generiert. Tritt der Fehler erneut auf, wende Dich bitte an app@grewe-gruppe.de.",
  genericErrorPageReload: "Seite neu laden",
  forbiddenHeader: "Fehlende Berechtigungen",
  forbiddenText: "Du hast keine Zugriffsberechtigung.",
  forbiddenFooter:
    "Wenn du glaubst, dass das nicht so sein sollte, melde dich bitte beim Team Digitalisierung unter app@grewe-gruppe.de.",
  tenantForbiddenHeader: "Fehlende Berechtigungen für {forbiddenTenantName}",
  tenantForbiddenText:
    "Aktuell fehlen dir die Berechtigungen, auf die Inhalte von <strong>{forbiddenTenantName}</strong> zuzugreifen.",
  tenantForbiddenLink: "Weiter zu {allowedTenantName}",
  geolocationError:
    "Bitte gib den Zugriff auf den Standort frei, um diese Funktion zu nutzen",
  teams: "Kolonnen",
  editTeam: "Kolonne bearbeiten",
  editSuccess: "Änderungen erfolgreich gespeichert",
  addTeam: "Kolonne hinzufügen",
  addTeamSuccess: "Kolonne erfolgreich hinzugefügt",
  deleteTeamSuccess: "Kolonne erfolgreich gelöscht",
  teamFormName: "Name",
  teamFormCancel: "Abbrechen",
  teamFormSave: "Speichern",
  teamFormDelete: "Löschen",
  teamConstructionSiteManagerLabel: "Bauleiter",
  teamConstructionSiteManagerError: "Bitte wähle einen Bauleiter.",
  teamFormItemMultiSelectorLabel: "Mitarbeiter o. Geräte suchen...",
  teamFormItemMultiSelectorError:
    "Bitte wähle mindestens einen Mitarbeiter oder ein Gerät.",
  unknownError:
    "Ein unbekannter Fehler ist aufgetreten. Bitte versuche es nochmal. Wir haben bereits eine Fehlermeldung im Hintergrund generiert. Tritt der Fehler erneut auf, wende Dich bitte an app@grewe-gruppe.de.",
  unknownEmployee: "Unbekannter Mitarbeiter",
  unknownTenant: "Unbekannter Mandant",
  unknownCategory: "Unbekannte Kategorie",
  unknownCategoryTooltip: "Kategorie nicht gefunden",
  unknownConstructionSiteManager: "Unbekannter Bauleiter",
  unknownWorkPackage: "Unbekanntes Arbeitspaket",
  unknownConstructionSite: "Unbekannte Baustelle",
  "name has already been taken": "Der Name ist bereits vergeben.",
  lv_identifier_taken: "Identifier bereits vergeben.",
  teamFormCurrentlyPartOf: "Ist aktuell Teil der Kolonne",
  teamFormAddPermanently: "Aus aktueller Kolonne dauerhaft übernehmen",
  teamFormAddAll: "Alle übernehmen",
  teamFormAllAdded: "Alle Änderungen übernommen",
  collapseRow: "Reihe einklappen",
  expandRow: "Reihe ausklappen",
  teamlessResources: "Mitarbeiter und Geräte ohne Kolonne",
  teamless: "Keiner Kolonne zugeordnet",
  tool: "Maschine",
  tools: "Maschinen",
  taskCustomer: "Kunde",
  taskDescription: "Kurzbeschreibung",
  taskPerformedActivities: "Durchgeführte Tätigkeiten",
  taskNote: "Notiz",
  name: "Name",
  editedAt: "Letzte Änderung",
  updateAvailable:
    "Ein Update ist verfügbar – klicke hier, um die App zu aktualisieren.",
  updateAvailableMobile: "Update verfügbar – jetzt aktualisieren.",
  invalidConstructionSites: "Fehlerhafte LVs",
  invalidConstructionSitesDescription:
    "Finde zu korrigierende Leistungsverträge.",
  invalidProjects: "Fehlerhafte Projekte",
  invalidProjectsDescription: "Finde zu korrigierende Projekte.",
  invalidProjectsInvalidProjectNumberReason:
    "Projekt hat eine ungültige Projektnummer.",
  invalidProjectsUnknownTenantNumberReason:
    "Projekt hat einen unbekannten Mandanten.",
  invalidProjectsUnknownReason:
    "Projekt ist ungültig. Der Grund '%{reason}' ist unbekannt.",
  invalidTools: "Fehlerhafte Geräte",
  invalidToolsDescription: "Finde zu korrigierende Gerätedaten.",
  invalidToolsNameMissing: "Name fehlt",
  invalidToolsTenantMissing: "Mandant fehlt",
  invalidToolsManagerMissing: "Manager fehlt",
  invalidToolsCategoryMissing: "Kategorie fehlt",
  invalidToolsToolIdMissing: "Geräte-ID fehlt",
  invalidToolsDailyRateMissing: "Tagessatz fehlt",
  invalidToolsMinuteRateMissing: "Minutensatz fehlt",
  invalidToolsAllTenants: "Alle Mandanten",
  workPackageFormName: "Name",
  workPackageFormCalculatedHours: "Kalkulierte Stunden",
  workPackageFormPlannedHours: "Geplante Stunden",
  workPackageFormCommuteExpensesEnabledLabel: "Wegegeld wird gezahlt",
  workPackageFormServiceCategoryLabel: "Leistungskategorie",
  workPackageFormLocationLabel: "Ausführungsort",
  workPackageFormNoteLabel: "Hinweis zur Ausführung an die Kolonne",
  workPackageFormServiceCategoryError: "Bitte wähle eine Leistungskategorie.",
  workPackageFormConstructionSiteManagerLabel: "Bauleiter",
  workPackageFormConstructionSiteManagerError: "Bitte wähle einen Bauleiter.",
  workPackageFormWageTypeLabel: "Lohnart",
  timeApprovalManagerAccountGroup: "Bauleiterkonto – {customer}",
  timeApprovalManagerAccountGroupWithoutTask:
    "Bauleiterkonto – ohne Auftragsinformationen",
  timeApprovalNoLocation: "Position nicht verfügbar.",
  timeApprovalOutdatedLocation: "Position ist veraltet.",
  timeApprovalLocationCurrentStartLocationTooFarAway:
    "Aktueller Ausführungsort: Die Entfernung des Einbuchens zum aktuellen Ausführungsort ist ungewöhnlich hoch (Fahrtweg: {distanceToWorkLocation}, Fahrzeit: {timeToWorkLocation}).",
  timeApprovalLocationPreviousLocationTooFarAway:
    "Vorheriger Ausführungsort: Die Entfernung des Einbuchens zum vorherigen Ausführungsort ist ungewöhnlich hoch (Fahrtweg: {distanceToWorkLocation}, Fahrzeit: {timeToWorkLocation}).",
  timeApprovalLocationCurrentStopLocationTooFarAway:
    "Aktueller Ausführungsort: Die Entfernung des Ausbuchens zum aktuellen Ausführungsort ist ungewöhnlich hoch (Fahrtweg: {distanceToWorkLocation}, Fahrzeit: {timeToWorkLocation}).",
  timeApprovalLocationNextLocationTooFarAway:
    "Nächster Ausführungsort: Die Entfernung des Ausbuchens zum nächsten Ausführungsort ist ungewöhnlich hoch (Fahrtweg: {distanceToWorkLocation}, Fahrzeit: {timeToWorkLocation}).",
  timeApprovalWorkPackageLocationMissing:
    "Entfernung kann nicht berechnet werden, da im Arbeitspaket kein Ausführungsort hinterlegt ist.",
  timeApprovalAnomaliesNotYetDetermined:
    "Fahrtweg und Fahrzeit zum aktuellen / vorherigen / nächsten Ausführungsort wurde bisher noch nicht berechnet.",
  timeApprovalTableEmployee: "Mitarbeiter/in oder Gerät",
  timeApprovalTableArrivalCommute: "Hinweg",
  timeApprovalTableDepartureCommute: "Rückweg",
  timeApprovalTableFrom: "von",
  timeApprovalTableTo: "bis",
  timeApprovalTableTimeRange: "von - bis",
  timeApprovalShowLocation: "Position auf Karte anzeigen.",
  timeApprovalAnomalousLocationTitle: "Es liegen Abweichungen vor.",
  timeApprovalTableBreak: "Pause",
  timeApprovalTableNet: "Netto",
  timeApprovalTableTask: "Arbeitspaket / Buchungskonto",
  timeApprovalTableConstructionSiteManager: "Bauleitende/r",
  timeApprovalApprovedTooltip:
    "Freigegeben am {approvedAt} Uhr durch {approvedBy}",
  timeApprovalAutomaticallyApprovedTooltip:
    "Automatisch freigegeben am {approvedAt} Uhr",
  timeApprovalAutomaticallyExportedTooltip:
    "Automatisch exportiert am {exportedAt} Uhr",
  timeApprovalExportedByTooltip:
    "Exportiert am {exportedAt} Uhr durch {exportedBy}",
  timeApprovalDeletedTooltipByUser:
    "Dieser Zeiteintrag wurde am {deletedAt} Uhr von {deletedBy} gelöscht",
  timeApprovalDeletedTooltipBySystem:
    "Dieser Zeiteintrag wurde am {deletedAt} Uhr automatisch gelöscht",
  timeApprovalDeleteButtonTooltipResourceName: "Zeiteintrag von {employee}",
  timeApprovalOverlappingTooltip:
    "Eintrag kann nicht freigegeben werden, da Überschneidungen mit anderen Einträgen bestehen.",
  timeApprovalCommuteTimeErrorTooltip:
    "Eintrag kann nicht freigegeben werden, da die Wegegeld-Fahrzeit nicht automatisch berechnet werden konnte.",
  timeApprovalCreateTimeTrackingDialogDateLabel: "Datum",
  timeApprovalFiltersDateRange: "Zeitraum",
  timeApprovalFiltersGrouping: "Gruppierung",
  timeApprovalFiltersGroupingTeam: "Kolonne",
  timeApprovalFiltersGroupingWorkPackage: "Arbeitspaket / Buchungskonto",
  timeApprovalFiltersGroupingEmployee: "Mitarbeiter / Gerät",
  timeApprovalFiltersGroupNameTeam: "Kolonnenname",
  timeApprovalFiltersGroupNameWorkPackage:
    "Arbeitspaketname / Baustellennummer",
  timeApprovalFiltersGroupNameEmployee: "Name / Nummer",
  timeApprovalFiltersSearch: "Suche",
  timeApprovalFiltersStatus: "Status",
  timeApprovalAnomaliesDropdownLabel: "Anomalien",
  timeApprovalAnomaliesDropdownPlaceholder: "Anomalien auswählen...",
  timeApprovalAnomaliesDropdownOption_exceedsMaxHours:
    "Überschreitung maximale Arbeitszeit",
  timeApprovalAnomaliesDropdownOption_employeeMultipleArrivalCommute:
    "Mehrfache Wegegeld-Auswahl für Hinfahrt",
  timeApprovalAnomaliesDropdownOption_employeeMultipleDepartureCommute:
    "Mehrfache Wegegeld-Auswahl für Rückfahrt",
  timeApprovalAnomaliesDropdownOption_multipleArrivalDriversOnTimeTracking:
    "Mehrere Fahrer Hinfahrt",
  timeApprovalAnomaliesDropdownOption_multipleDepartureDriversOnTimeTracking:
    "Mehrere Fahrer Rückfahrt",
  timeApprovalAnomaliesDropdownOption_arrivalCommuteTimeBiggerThanTrackingSwitchTime:
    "Wegegeld-Fahrzeit Hinfahrt größer als Wechselzeit",
  timeApprovalAnomaliesDropdownOption_departureCommuteTimeBiggerThanTrackingSwitchTime:
    "Wegegeld-Fahrzeit Rückfahrt größer als Wechselzeit",
  timeApprovalAnomaliesDropdownOption_commuteTimeWithoutCalculation:
    "Wegegeld-Fahrzeit ohne Berechnung",
  timeApprovalColumnsCommute: "Wegegeld-Fahrzeit",
  timeApprovalColumnsConstructionSiteManager: "Bauleitende/r",
  timeApprovalColumnsEmployee: "Mitarbeiter",
  timeApprovalColumnsFrom: "Von",
  timeApprovalColumnsTo: "Bis",
  timeApprovalColumnsBreak: "Pause",
  timeApprovalColumnsNet: "Netto",
  timeApprovalColumnsTeam: "Kolonne",
  timeApprovalColumnsTask: "Arbeitspaket / Buchungskonto",
  timeApprovalColumnsStatus: "Status",
  timeApprovalColumnsActions: "Aktionen",
  timeApprovalCellTotal: "Gesamt",
  timeApprovalTaskInformation: "Auftragsinformationen",
  timeApprovalTaskModalTaskInfosMissing:
    "Keine Auftragsinformationen hinterlegt",
  timeApprovalTaskModalAssignTitle: "Buchungen zuordnen",
  timeApprovalTaskModalAssignButton: "Zuordnen",
  timeApprovalTaskModalAssignWorkPackage: "Arbeitspaket zuordnen",
  timeApprovalTaskModalAssignConstructionSiteManager:
    "Anderem Bauleitenden zuordnen",
  timeApprovalTaskModalAssignTraining: "Weiterbildung zuordnen",
  timeApprovalActionButtonsTaskModalTooltip: "Buchungen zuordnen",
  timeApprovalActionButtonsApproveTooltip: "Freigeben",
  timeApprovalActionButtonsUnapproveTooltip: "Freigabe rückgängig machen",
  timeApprovalActionButtonsEditTooltip: "Buchungen bearbeiten",
  timeApprovalEditTimeEntriesFormModalTitle: "Buchungen bearbeiten",
  timeApprovalCreateTimeEntriesFormModalTitle: "Buchungen erstellen",
  timeApprovalNoTeam: "(Ohne Kolonne)",
  timeApprovalOverlappingUndoTooltip:
    "Eintrag kann nicht freigegeben werden, da er sich mit anderen Einträgen überschneidet.",
  timeApprovalTimeEntriesFormModalSave: "Speichern",
  timeApprovalTimeEntriesFormModalSaveWithApprove: "Speichern und freigeben",
  timeApprovalTimeEntriesFormModalSecondPrecisionLabel: "sekundengenau",
  timeApprovalTimeEntriesFormModalCommuteTimeError:
    "Wegegeld-Fahrzeit konnte nicht automatisch berechnet werden. Bitte gib die Wegegeld-Fahrzeit manuell ein.",
  timeApprovalNewAbsenceFormModalTitle: "Abwesenheitsbuchung erstellen",
  timeApprovalNewAbsenceFormModalHint:
    "Um Abwesenheiten über mehrere Tage hinweg zu planen, nutze den Bereich",
  timeApprovalNewAbsenceFormModalHintLink: "Abwesenheiten",
  timeApprovalNewAbsenceFormEmployeePlaceholder: "Mitarbeiter auswählen",
  timeApprovalNewTrainingFormModalTitle: "Weiterbildung eintragen",
  timeApprovalSpeedDialNewWorkingHours: "Neue Arbeitszeit",
  timeApprovalSpeedDialNewAbsence: "Neue Abwesenheit",
  timeApprovalSpeedDialNewTraining: "Neue Weiterbildung",
  timeApprovalNetDurationWholeDayTooltip:
    "Als Netto-Zeit für die Abwesenheit wird die zugrundeliegende vertragliche Arbeitszeit des jeweiligen Mitarbeitenden angesetzt.",
  timeApprovalMultipleArrivalCommuteTooltip:
    "Für diesen Mitarbeitenden gibt es zwei Zeitbuchungen an einem Tag, bei denen ein Abfahrtsort für die Berechnung von Wegegeld ausgewählt wurde.",
  timeApprovalMultipleDepartureCommuteTooltip:
    "Für diesen Mitarbeitenden gibt es zwei Zeitbuchungen an einem Tag, bei denen ein Zielort für die Berechnung von Wegegeld ausgewählt wurde.",
  timeApprovalMultipleDriversOnTimeTrackingArrivalTooltip:
    "Bei dieser Zeitbuchung wurden bei der Hinfahrt mehrere Mitarbeitende als Fahrer ausgewählt.",
  timeApprovalMultipleDriversOnTimeTrackingDepartureTooltip:
    "Bei dieser Zeitbuchung wurden bei der Rückfahrt mehrere Mitarbeitende als Fahrer ausgewählt.",
  timeApprovalArrivalCommuteTimeBiggerThanTrackingSwitchTimeTooltip:
    "Die Fahrzeit des Wegegeldes ist größer als die Zeit zwischen dem letzten Ausbuchen und dem Einbuchen auf diesem Arbeitspaket.",
  timeApprovalDepartureCommuteTimeBiggerThanTrackingSwitchTimeTooltip:
    "Die Fahrzeit des Wegegeldes ist größer als die Zeit zwischen dem Ausbuchen auf diesem Arbeitspaket und dem nächsten Einbuchen.",
  invalidDateRangeInfo: `
    Bitte wähle einen gültigen Zeitraum aus.
    <br />
    Um übermäßig lange Ladezeiten zu vermeiden, kannst du nur einen Zeitraum
    von <strong>maximal 6 Monaten</strong> wählen.
  `,
  timeApprovalEmptyResultInfo:
    "Für die ausgewählten Suchkriterien konnten keine Buchungen gefunden werden.",
  timeApprovalActionButtonsHistoryTooltip: "Änderungshistorie anzeigen",
  timeApprovalToolTooltip: "Geräte werden automatisch freigegeben.",
  timeApprovalConfirmDialogTitle: "Überschreiten der maximalen Arbeitszeit",
  timeApprovalConfirmDialogText:
    "Für folgende Mitarbeitende würde die Gesamtzahl der gebuchten Stunden 10 übersteigen:",
  timeApprovalConfirmDialogOk: "Trotzdem freigeben",
  timeApprovalConfirmDialogCancel: "Abbrechen",
  timeApprovalFooterTotal: "Gesamt",
  timeApprovalFooterTotalUnit: "Buchungen",
  timeApprovalFooterEmployeesCount: "# gebuchte Personen",
  timeApprovalFooterEmployeesCountLong: "Anzahl der gebuchten Personen",
  timeApprovalFooterToolsCount: "# gebuchte Geräte",
  timeApprovalFooterToolsCountLong: "Anzahl der gebuchten Geräte",
  timeApprovalFooterProductiveHours: "𝛴 Produktivstunden",
  timeApprovalFooterProductiveHoursLong:
    "Summe der produktiven Personenstunden",
  timeApprovalFooterNonProductiveHours: "𝛴 sonst. Stunden",
  timeApprovalFooterNonProductiveHoursLong:
    "Summe der nicht-produktiven Personenstunden",
  timeApprovalFooterToolsHours: "𝛴 Gerätestunden",
  timeApprovalFooterToolsHoursLong: "Summe der Gerätestunden",
  timeApprovalTaskModalAssignWorkPackageLabel: "Arbeitspaket",
  timeApprovalTaskModalAssignWorkPackageError: "Bitte wähle ein Arbeitspaket",
  timeApprovalTaskModalAssignConstructionSiteManagerLabel: "Bauleitende/r",
  timeApprovalTaskModalAssignConstructionSiteManagerError:
    "Bitte wähle eine/n Bauleitende/n",
  timeApprovalExportButtonLabel: "Zeiten exportieren",
  timeApprovalExportButtonTooltip:
    "Es werden keine Geräte und Bauleiterkontobuchungen exportiert.",
  timeApprovalExportCsvDate: "Datum",
  timeApprovalExportCsvTeam: "Kolonne",
  timeApprovalExportCsvStaffNumber: "Personal-Nummer",
  timeApprovalExportCsvLastName: "Name",
  timeApprovalExportCsvFirstName: "Vorname",
  timeApprovalExportCsvConstructionSiteNumber: "Baustellen-Nummer",
  timeApprovalExportCsvTask: "Arbeitspaket/Buchungskonto",
  timeApprovalExportCsvStartTime: "Startzeit",
  timeApprovalExportCsvStopTime: "Endzeit",
  timeApprovalExportCsvBreak: "Pause",
  timeApprovalExportCsvStartPosition: "Start-Position (GPS-Daten)",
  timeApprovalExportCsvEndPosition: "End-Position (GPS-Daten)",
  timeApprovalExportCsvStatus: "Status",
  timeApprovalExportCsvFilterName: "Filter",
  timeApprovalExportCsvFilterValue: "Wert",
  timeApprovalExportCsvFilterDateRange: "Zeitraum",
  timeApprovalExportCsvFilterGrouping: "Gruppierung",
  timeApprovalExportCsvFilterSearch: "Suchfeld",
  timeApprovalExportCsvFilterResourceType: "Mitarbeitende/Geräte",
  timeApprovalExportCsvFilterStatus: "Status",
  timeApprovalExportCsvFilterAnomalies: "Anomalien",
  timeApprovalExportCsvFilterOnlyOverlapping: "Konflikte",
  editTimeEntryAddEntry: "Eintrag hinzufügen",
  editTimeEntryErrorOverlapping:
    "Diese Zeit überschneidet sich mit anderen Zeitenbuchungen",
  editTimeEntryConflictTooltipHeader: "Steht im Konflikt mit folgenden Zeiten:",
  editTimeEntryErrorRequired: "Pflichtfeld",
  editTimeEntryErrorStartTimeGreaterThanStopTime: "Start muss vor Ende liegen",
  editTimeEntryErrorStopTimeLowerThanStartTime: "Ende muss hinter Start liegen",
  editTimeEntryNoEmployeeAvailable: "Keine Mitarbeiter/Geräte verfügbar",
  editTimeEntryNoWorkPackagesAvailable: "Keine Arbeitspakete verfügbar",
  editTimeEntrySelectEmployee: "Mitarbeiter/Gerät auswählen",
  editTimeEntrySelectWorkPackage: "Arbeitspaket auswählen",
  editTimeEntryUnknownWorkPackage: "Unbekanntes Arbeitspaket",
  loggedInAs: "Angemeldet als",
  loginAnotherUser: "Neuen Benutzer anmelden",
  loginPageTitle: "Willkommen bei der grewe-gruppe",
  loginPageTextHtml: `
    <p>
      Wir befinden uns zurzeit noch in der <strong>Testphase</strong>.
      Es kann also sein, dass Du beim Benutzen noch Kinderkrankheiten entdeckst.
      Die gebuchten Zeiten werden bereits von der Lohnbuchhaltung verwendet.
    </p>
    <p>
      Falls Du etwas entdeckst, was nicht so funktioniert, wie von Dir
      erwartet, dann schreibe uns bitte eine kurze Mail an <a href="mailto:app@grewe-gruppe.de">app@grewe-gruppe.de</a> und
      teile uns mit, was Du gemacht hast, was passiert ist und was Du erwartet
      hättest.
    </p>
    <p>
      Die Anmeldung erfolgt über Deinen Microsoft-Account. Beim ersten Login
      musst Du der App lediglich die benötigten Zugriffsrechte gewähren und im
      Anschluss kann es auch schon losgehen!
    </p>
  `,
  moreLoadingInfo:
    "Das Laden dauert länger als erwartet. Bitte gedulde dich noch etwas. Wenn es sehr lange dauert überprüfe ob du eine Internet-Verbindung hast.",
  selectForeman: "Kolonnenverantwortlichen wählen",
  foremanRequired: "Bitte einen Kolonnenverantwortlichen wählen.",
  timeEntryExport: "Zeitenexport",
  timeEntryExportDescription:
    "Exportiere Zeitenbuchungen für die Lohnbuchhaltung.",
  timeEntryExportDateRangeLabel: "Zeitraum",
  timeEntryExportTenantLabel: "Mandant",
  timeEntryExportTenantNoOptions: "Keine Mandanten auswählbar",
  timeEntryExportIncludeAlreadyExportedLabel:
    "Auch bereits exportierte Zeiten einschließen",
  timeEntryExportSubmitButtonLabel: "Zeiten per Email exportieren",
  timeEntryExportFileNameFromPlaceholder: "{von}",
  timeEntryExportFileNameUntilPlaceholder: "{bis}",
  timeEntryExportFileNameTenantPlaceholder: "{mandant}",
  timeEntryExportStepOneTitle: "Schritt 1",
  timeEntryExportStepOneSubtitle: "Mandanten wählen",
  timeEntryExportStepTwoTitle: "Schritt 2",
  timeEntryExportStepTwoSubtitle: "Export konfigurieren",
  timeEntryExportStepThreeTitle: "Schritt 3",
  timeEntryExportStepThreeSubtitle: "Zeiten als CSV-Datei per Email erhalten",
  timeEntryExportPreviewTitle: "Export-Vorschau",
  timeEntryExportPreviewEmptyResultTitle: "Keine Buchungen gefunden!",
  timeEntryExportPreviewEmptyResultContent:
    "Entweder haben Sie die Buchungen bereits exportiert oder es wurden keine Buchungen zu den gewählten Exportkriterien gefunden.",
  timeEntryExportPreviewChooseCriteria:
    "Wähle den Mandanten und den Zeitraum, um die beinhalteten Buchungen zu sehen",
  timeEntryExportSuccessToast:
    "Die Zeitbuchungen wurden erfolgreich exportiert und per Email versendet.",
  closeSnackbar: "Schließen",
  offlineBannerMessage: "Du bist offline.",
  openSidebar: "Navigation öffnen",
  closeSidebar: "Navigation schließen",
  monitoringRunningTimeTrackingsHeadline: "Aktive Zeitbuchungen",
  monitoringRunningTimeTrackingsActive: "aktiv",
  monitoringRunningTimeTrackingsEmployeeCountTextSingular:
    "aktive(r) Mitarbeitende(r)",
  monitoringRunningTimeTrackingsEmployeeCountTextPlural: "aktive Mitarbeitende",
  monitoringRunningTimeTrackingsToolCountTextSingular: "aktives Gerät",
  monitoringRunningTimeTrackingsToolCountTextPlural: "aktive Geräte",
  monitoringNoRunningTimeTrackings: "Aktuell ist niemand eingebucht...",
  monitoringTimeEntriesTableHeadEmployee: "Mitarbeiternde / Geräte",
  monitoringTimeEntriesTableHeadFrom: "seit",
  monitoringTimeEntriesTableHeadWorkPackage: "Arbeitspaket oder Bauleiter",
  monitoringConstructionSiteManagerAccountOf: "Bauleiterkonto von {name}",
  monitoringConstructionSiteManagerAccount: "Bauleiterkonto",
  monitoringTraining: "Weiterbildung",
  teamPlanning: "Kolonnenbezogene Planung",
  teamPlanningDescription: "Prüfe die Auslastung deiner Kolonnen.",
  teamPlanningCalendarWeekAbbr: "KW",
  teamPlanningTeamsTableHeader: "Kolonnen",
  teamPlanningEmployeesTableHeader: "Mitarbeitende/r",
  teamPlanningConstructionSitesTableHeader: "Baustellen",
  teamPlanningPreviousWeek: "vorherige Woche",
  teamPlanningNextWeek: "nächste Woche",
  teamPlanningPreviousMonth: "vorheriger Monat",
  teamPlanningNextMonth: "nächster Monat",
  teamPlanningPreviousThreeMonths: "vorherige 12 Wochen",
  teamPlanningNextThreeMonths: "nächste 12 Wochen",
  teamPlanningTeamlessEmployeesSectionHeader: "Mitarbeiter ohne Kolonne",
  teamPlanningTeamlessToolsSectionHeader: "Geräte ohne Kolonne",
  teamPlanningWeekDropdownCurrentWeekOption: "Aktuelle Woche",
  teamPlanningExpandAll: "Alle aufklappen",
  teamPlanningDateUnitSelectWeek: "Woche",
  teamPlanningDateUnitSelectMonth: "Monat",
  teamPlanningDateUnitSelectThreeMonths: "12 Wochen",
  teamPlanningGroupingSelectTeam: "Kolonne",
  teamPlanningGroupingSelectEmployee: "Mitarbeiter",
  teamPlanningGroupingSelectConstructionSite: "Baustelle",
  teamPlanningPlanEntryTypeSelectAll: "Alle",
  teamPlanningPlanEntryTypeSelectWorkPackage: "Arbeitspakete",
  teamPlanningPlanEntryTypeSelectAbsence: "Abwesenheiten",
  teamPlanningDrawerWorkPackageLabel: "Arbeitspaket",
  teamPlanningDrawerDateRangeLabel: "Zeitraum",
  teamPlanningDrawerManagerLabel: "Bauleiter",
  teamPlanningDrawerServiceCategoryLabel: "Leistungskategorie",
  teamPlanningDrawerPlanningLink: "Zur Planung",
  teamPlanningDrawerTimePeriodModalLink: "Zeitraum verschieben",
  teamPlanningTimePeriodModalTitle: "Kolonnenplanung verschieben",
  teamPlanningTimePeriodModalSubmitButton: "Verschieben",
  teamPlanningTimePeriodModalByLabel: "um",
  teamPlanningTimePeriodModalToLabel: "auf den",
  teamPlanningTimePeriodModalUnitDay: "Tage",
  teamPlanningTimePeriodModalUnitWeek: "Wochen",
  teamPlanningTimePeriodModalCountLabel: "Anzahl",
  teamPlanningTimePeriodModalUnitLabel: "Tage oder Wochen",
  teamPlanningTimePeriodModalDateLabel: "Datum",
  appAdmin: "Debug & Config",
  appAdminSettings: "Config & Debug",
  appAdminStats: "Stats",
  settingsButton: "Einstellungen",
  settingsCloseButton: "Einstellungen schließen",
  settingsHeader: "Einstellungen",
  settingsLanguageTitle: "Sprache",
  settingsBetaTitle: "Modus",
  settingsBetaDescription:
    "Wenn du den BETA-Modus aktivierst, kannst du neue Features testen.",
  settingsNextAvailableProjectNumber: "Nächste freie Projektnummer",
  settingsErrorFetchingNextProjectNumber:
    "Die nächste Projektnummer konnte nicht abgerufen werden.",
  settingsBetaDisabled: "NORMAL",
  settingsBetaEnabled: "BETA",
  SettingsWereSaved: "Einstellungen wurden gespeichert",
  statistics: "Statistiken",
  statisticsDescription: "Prüfe die Nutzung der grewe-gruppe App.",
  statisticsCurrentTenant: "Aktueller Mandant",
  statisticsAllTenants: "Gesamte Gruppe",
  statisticsHeaderStatistics: "Statistiken",
  statisticsHeaderTotal: "Insgesamt",
  statisticsColumnTitleTeams: "Kolonnen (durchschn. gew. MA / Kolonne)",
  statisticsColumnTitleTeamsTooltip:
    "Ermittelt mit dem Datum seit dem die Kolonne in der Grewe-Gruppe App erstellt wurde.",
  statisticsColumnTitleEmployees: "Mitarbeiter insgesamt",
  statisticsColumnTitleEmployeesTooltip:
    "Ermittelt mit dem Start- oder Erstelldatum",
  statisticsColumnTitleBlueCollarEmployees:
    "Gewerbliche Mitarbeiter (vs. Mitarbeiter insg.)",
  statisticsColumnTitleBlueCollarEmployeesTooltip:
    "Ermittelt mit dem Start- oder Erstelldatum und der Rolle gewerbliche Mitarbeiter",
  statisticsColumnTitleConstructionSiteManagers:
    "Bauleiter (inkl. GLs) (vs. gew. MA)",
  statisticsColumnTitleConstructionSiteManagersTooltip:
    "Ermittelt mit dem Start- oder Erstelldatum und der Rolle Bauleiter ink. Geschäftsleitung",
  statisticsColumnTitleWorkPackages:
    "Erstellte Arbeitspakete (Durchschn. Arbeitspakete pro Baustelle)",
  statisticsColumnTitleWorkPackagesTooltip:
    "Ermittelt mit dem Datum seit dem das Arbeitspaket in der Grewe-Gruppe App erstellt wurde. (Arbeitspakete geteilt durch alle Baustellen mit min. einem Arbeitspaket)",
  statisticsColumnTitleConstructionSites: "Aktive Baustellen",
  statisticsColumnTitleConstructionSitesTooltip:
    "Ermittelt mit dem Datum Seit dem die Grewe-Gruppe App erstmals die Baustelle erfasst/synchronisiert hat.",
  statisticsColumnTitleConstructionSitesWithWorkPackages:
    "Baustellen mit Arbeitspaketen (vs. Baustellen insg.)",
  statisticsColumnTitleAppendedEmployeeTimeEntries:
    "Manuell erfasste Buchungen (vs. Buchungen insg.)",
  statisticsColumnTitleAppendedEmployeeTimeEntriesTooltip:
    "Alle Zeitbuchungen mit der Eingenschaft ahngehängt (append)",
  statisticsColumnTitleModifiedEmployeeTimeEntries:
    "Editierte Buchungen (vs. Buchungen insg.)",
  statisticsColumnTitleModifiedEmployeeTimeEntriesTooltip:
    "Alle Zeitbuchungen mit der Eingenschaft geändert (modified)",
  statisticsColumnTitleApprovedUnexportedEmployeeTimeEntries:
    "Freigegeben aber noch nicht exportiert",
  statisticsColumnTitleApprovedUnexportedEmployeeTimeEntriesTooltip:
    "Alle Zeitbuchungen mit der Eingenschaft freigegben aber nicht exportiert",
  statisticsColumnTitleTimeEntriesTrackedByDistinctEmployees:
    "Anzahl Buchungen von individ. Mitarbeitern",
  statisticsColumnTitleTimeEntriesTrackedByDistinctEmployeesTooltip:
    "Anzahl der gestarteten Zeitbuchungen pro Mitarbeiter zusammengefasst",
  statisticsColumnTitleTimeEntriesApprovedByDistinctEmployees:
    "Anzahl freigegebene Buchungen von individ. Mitarbeitern",
  statisticsColumnTitleTimeEntriesApprovedByDistinctEmployeesTooltip:
    "Anzahl der freigebenen Zeitbuchungen pro Mitarbeiter zusammengefasst",
  statisticsColumnTitleAverageDaysBetweenStartAndApproval:
    "Durchschnittliche Anzahl Tage zwischen Buchung und Freigabe",
  statisticsColumnTitleAverageDaysBetweenStartAndApprovalTooltip:
    "Die Summe aller Tage dividiert durch die Anzahl aller Tage von Startdatum bis Abnahmedatum.",
  statisticsColumnTitleAverageDaysBetweenApprovalAndExport:
    "Durchschnittliche Anzahl Tage zwischen Freigabe und Export",
  statisticsColumnTitleAverageDaysBetweenApprovalAndExportTooltip:
    "Die Summe aller Tage dividiert durch die Anzahl aller Tage von Abnahmedatum bis Exportdatum.",
  statisticsColumnTitleAverageDaysBetweenStartAndExport:
    "Durchschnittliche Anzahl Tage zwischen Buchung und Export",
  statisticsColumnTitleAverageDaysBetweenStartAndExportTooltip:
    "Die Summe aller Tage dividiert durch die Anzahl aller Tage von Startdatum bis Exportdatum.",
  statisticsColumnTitleExportedEmployeeTimeEntries: "Exportierte Buchungen",
  statisticsColumnTitleExportedEmployeeTimeEntriesTooltip:
    "Alle Zeitbuchungen die exportiert wurden",
  statisticsColumnTitleEmployeeTimeEntries: "Buchungen insgesamt",
  statisticsColumnTitleEmployeeTimeEntriesTooltip:
    "Alle gestarteten Zeitbuchungen",
  statisticsRowTotalTeams: "Insgesamt",
  statisticsRowAddedTeams: "Neu",
  statisticsRowDeletedTeams: "Gelöscht",
  statisticsRowAddedEmployees: "Neu",
  statisticsRowResignedEmployees: "Gekündigt",
  statisticsRowTotalEmployees: "Insgesamt",
  statisticsRowAddedConstructionSites: "Neu",
  statisticsRowDeletedConstructionSites: "Gelöscht",
  statisticsRowTotalConstructionSites: "Insgesamt",
  statisticsColumnTitleAverageCommuteTime:
    "Durchschnittliche Wegegeld-Fahrzeit in Minuten",
  statisticsColumnTitleAverageCommuteTimeTooltip:
    "Die Summe der Wegegeld-Fahrzeiten aller Fahrten als Fahrer/Beifahrer dividiert durch die Anzahl der Fahrten als Fahrer/Beifahrer",
  statisticsColumnTitleCommuteTimeCounts:
    "Anzahl Fahrten Baustelle <> Betriebshof/Zuhause",
  statisticsColumnTitleCommuteTimeCountsTooltip:
    "Anzahl der Hin-/ Rückwegauswahl pro Mitarbeiter zusammengefasst",
  statisticsRowAverageCommuteTimeAsDriver: "Fahrer/in",
  statisticsRowAverageCommuteTimeAsPassenger: "Beifahrer/in",
  statisticsRowCommuteTimeCountsArrivalSite: "Hinfahrten vom Betriebshof",
  statisticsRowCommuteTimeCountsArrivalHome: "Hinfahrten von Zuhause",
  statisticsRowCommuteTimeCountsDepartureSite: "Rückfahrten zum Betriebshof",
  statisticsRowCommuteTimeCountsDepartureHome: "Rückfahrten nach Zuhause",
  timeEntryHistoryModalTitle: "Änderungshistorie",
  timeEntryHistoryModalTitleEntryFrom: "Buchung vom",
  timeEntryHistoryModalChangeInfoStartAction: "Zeiterfassung gestartet von",
  timeEntryHistoryModalChangeInfoAppendActionByEmployee:
    "Zeiterfassung manuell erstellt von",
  timeEntryHistoryModalChangeInfoAppendActionBySystem:
    "Zeiterfassung automatisch erstellt",
  timeEntryHistoryModalChangeInfoStopAction: "Zeiterfassung gestoppt von",
  timeEntryHistoryModalChangeInfoAutoStopAction:
    "Zeiterfassung automatisch gestoppt durch das Gerät von",
  timeEntryHistoryModalChangeInfoForceStopAction:
    "Zeiterfassung im Monitoring gestoppt von",
  timeEntryHistoryModalChangeInfoModifyAction: "Manuelle Änderungen von",
  timeEntryHistoryModalChangeInfoApproveActionByEmployee: "Freigegeben von",
  timeEntryHistoryModalChangeInfoApproveActionBySystem:
    "Automatisch freigegeben",
  timeEntryHistoryModalChangeInfoUnapproveAction: "Freigabe zurückgenommen von",
  timeEntryHistoryModalChangeInfoExportActionByEmployee: "Exportiert von",
  timeEntryHistoryModalChangeInfoExportActionBySystem: "Automatisch exportiert",
  timeEntryHistoryModalChangeInfoUpdateCommuteTypeAction:
    "Wegegeld-Abfrage erfasst",
  timeEntryHistoryModalChangeInfoUpdateAdjacentLocationValuesChargeableHoursAction:
    "Berechnung der Entfernung zum Ausführungsort",
  timeEntryHistoryModalChangeInfoUpdateAdjacentLocationValuesPreparationAction:
    "Berechnung der Entfernung zum Betriebshof",
  timeEntryHistoryModalChangeInfoCommuteTimeAction:
    "Wegegeld-Fahrzeit wurde im Hintergrund berechnet",
  timeEntryHistoryModalChangeInfoDeleteActionByEmployee: "Gelöscht von",
  timeEntryHistoryModalChangeInfoDeleteActionBySystem: "Automatisch gelöscht",
  timeEntryHistoryWorkPackageLabel: "Arbeitspaket",
  timeEntryHistoryManagerLabel: "Bauleiterbuchung",
  timeEntryHistoryAbsenceLabel: "Buchungskonto",
  timeEntryHistoryGenericTaskLabel: "Aufgabe",
  myTimeEntries: "Meine Zeiten",
  myTimeEntriesDescription: "Überprüfe den Status deiner gebuchten Zeiten.",
  myTimeEntriesFromLabel: "von",
  myTimeEntriesToLabel: "bis",
  myTimeEntriesArrivalCommuteLabel: "Hinweg",
  myTimeEntriesDepartureCommuteLabel: "Rückweg",
  myTimeEntriesTotalCommuteLabel: "Summe der Wegegeld-Fahrzeit",
  myTimeEntriesBreakLabel: "Pause",
  myTimeEntriesNetLabel: "Netto",
  myTimeEntriesWorkPackageLabel: "Arbeitspaket",
  myTimeEntriesManagerLabel: "Bauleiter",
  myTimeEntriesAbsenceLabel: "Buchungskonto",
  myTimeEntriesStatusLabel: "Status",
  myTimeEntriesEmptyResultTitle: "Keine Zeiteinträge für diese Woche",
  myTimeEntriesEmptyResultContent: "Bitte überprüfen Sie ihre Filterkriterien",
  myTimeEntriesEmployeeSelectAllOption: "Alle Mitarbeiter",
  timeTrackingSynchronizedTitle: "Buchung synchronisiert",
  timeTrackingOfflineTitle: "Buchung nicht synchronisiert",
  timeTrackingOfflineDescription:
    "Deine Zeiten sind zwischengespeichert und werden automatisch synchronisiert sobald du mit dem Internet verbunden bist.",
  timeTrackingPositionErrorTitle: "Standort-Ermittlung blockiert",
  timeTrackingPositionErrorContentParagraph1:
    "Für das Starten und Stoppen der Zeiterfassung wird dein Standort benötigt. Bitte erlaubt daher die GPS-Ermittlung, wenn du danach gefragt wirst.",
  timeTrackingPositionErrorContentParagraph2:
    "Sollte der GPS-Empfang deaktiviert sein, kannst du es in den Systemeinstellungen deines Smartphones aktivieren.",
  timeTrackingPositionUnavailableErrorContentParagraph1:
    "Positionsbestimmung ist leider fehlgeschlagen.",
  timeTrackingPositionTimeoutErrorContentParagraph1:
    "Positionsbestimmung hat zu lange gedauert.",
  timeTrackingPositionRetryableErrorContentParagraph2:
    "Falls Du Dich in einem Gebäude, Auto oder z.B. unter einer Brücke befindest, gehe bitte ins Freie und versuche es dort noch einmal.",
  timeTrackingPositionUnsupportedErrorContentParagraph1:
    "Dein Browser unterstützt leider kein GPS-Tracking.",
  timeTrackingPositionUnsupportedErrorContentParagraph2:
    "Bitte aktualisiere deinen Browser oder verwende einen anderen modernen Browser (z.B. chrome).",
  timeTrackingPositionUnknownErrorContentParagraph1:
    "Ein unbekannter Fehler ist aufgetreten.",
  timeTrackingPositionErrorConfirm: "vertanden",
  taskBarAgeTooltip:
    "Es gibt Zeitbuchungen die älter als {ageInDays} Tage sind.",
  searchFieldLabel: "Suche",
  toolAdministrationAvailable: "Verfügbar",
  toolAdministrationAssigned: "Vorgemerkt",
  toolAdministrationI: "Ich",
  toolAdministrationCategoryFieldLabel: "Kategorie",
  toolAdministrationBillabilityFieldLabel: "Geräteart",
  toolAdministrationBillabilityOptionBillable: "Leistungsgeräte",
  toolAdministrationBillabilityOptionNonBillable: "Gemeinkostengeräte",
  toolAdministrationStatusFieldLabel: "Status",
  toolAdministrationStatusOptionActive: "Aktiv",
  toolAdministrationStatusOptionInactive: "Inaktiv",
  toolAdministrationInventoryStatusFieldLabel: "Inventur-Status",
  toolAdministrationInventoryYearFieldLabel: "Inventur-Zeitraum",
  toolAdministrationInventoryStatusOptionDone: "Inventarisiert",
  toolAdministrationInventoryStatusOptionOpen: "Nicht inventarisiert",
  toolAdministrationEmptyResultsInfo:
    "Für die ausgewählten Suchkriterien konnten keine Geräte gefunden werden.",
  toolAdministationMyAssignedTasks: "Für dich vorgemerkt",
  toolAdministrationInventoryButtonLabel: "Inventarisieren",
  toolAdministrationInventorySegment:
    "Inventur (Zum Inventarisieren Foto von Gerät hochladen)",
  toolAdministrationInventoryStatusSegment: "Status",
  toolAdministrationInventoryPictureSegment: "Bilder",
  toolAdministrationInventoryHistorySegment: "Historie",
  toolAdministrationInventoryHistoryColumnDate: "Ort / Datum",
  toolAdministrationInventoryHistoryColumnEventType: "Inventarisierung",
  toolAdministrationInventoryHistoryColumnUpdatedBy: "Geändert durch",
  toolAdministrationInventoryHistoryColumnPhotos: "Fotos",
  toolAdministrationInventoryHistoryColumnAction: "Aktion",
  toolAdministrationInventoryHistoryCreatedChip: "Erstellt",
  toolAdministrationInventoryHistoryUpdatedChip: "Bearbeitet",
  toolAdministrationInventoryHistoryDeletedChip: "Gelöscht",
  toolAdministrationInventoryHistoryMovedFromChip: "Eingefügt",
  toolAdministrationInventoryHistoryMovedToChip: "Verschoben",
  toolAdministrationInventoryHistoryNoEntry: "Gerät wurde nicht erfasst",
  toolAdministrationInventoryHistoryMovedToLink: "nach",
  toolAdministrationInventoryHistoryMovedFromLink: "aus",
  toolAdministrationInventoryHistoryActionMenu: "Inventuraktionen",
  toolAdministrationInventoryHistoryDeleteMenuItem: "Löschen",
  toolAdministrationInventoryHistoryMoveMenuItem: "Verschieben",
  toolAdministrationInventoryHistoryEditMenuItem: "Bearbeiten",
  toolAdministrationMoveInventoryDialogTitle: "Inventarisierung verschieben",
  toolAdministrationMoveInventoryDialogResultInfo:
    "Es gibt zu viele Treffer für deine Suchanfrage. Bitte verfeinere deine Suche.",
  toolAdministrationMoveInventoryDialogSubmitButton: "Verschieben",
  toolAdministrationMoveInventoryEmptyResult:
    "Für den Suchbegriff '{searchText}' wurden keine Geräte mit dem Status \"nicht inventarisiert\" gefunden.",
  toolAdministrationInventoryStateDone: "Inventarisiert",
  toolAdministrationInventoryStateOpen: "Nicht inventarisiert",
  toolAdministrationInventoryDrawerTitle: "{toolName} inventarisieren",
  toolAdministrationInventoryTakePicture: "Foto schießen",
  toolAdministrationInventoryChoosePicture: "Foto wählen...",
  toolAdministrationInventoryUploadCountSingular: "{count} Foto ausgewählt",
  toolAdministrationInventoryUploadCountPlural: "{count} Fotos ausgewählt",
  toolAdministrationInventoryUploadHint:
    "Mit Hochladen der Fotos wird das Gerät für die aktuelle <strong>Inventur {inventoryYear}</strong> als inventarisiert vermerkt.",
  toolAdministrationInventoryUploadButtonLabelSingular:
    "{count} Foto hochladen",
  toolAdministrationInventoryUploadButtonLabelPlural: "{count} Fotos hochladen",
  toolAdministrationInventoryOfflineError:
    "Du kannst das Gerät nicht inventarisieren, da du gerade offline bist.",
  toolAdministrationDocumentsOfflineError:
    "Du kannst die Dokumente nicht öffnen, da du offline bist.",
  toolAdministrationInventoryUploadSuccess: "Gerät erfolgreich inventarisiert",
  toolAdministrationInventoryUpdateSuccess: "Inventarisierung aktualisiert",
  toolAdministrationInventoryDeleteSuccess: "Inventarisierung gelöscht",
  toolAdministrationInventoryMoveSuccess: "Inventarisierung verschoben",
  toolAdministrationInventoryAddMorePictures: "Mehr Fotos hinzufügen",
  toolAdministrationInventoryRemovePictures: "Foto {filename} entfernen",
  toolAdministrationInventoryDateColumn: "Inventarisierung am",
  toolAdministrationInventoryStatusColumn: "Inventur-Status",
  toolAdministrationInventoryColumnActionUploadPhotoTooltip:
    "Zum Inventarisieren Fotos hochladen",
  toolAdministrationInventoryColumnActionUploadPhotoTooltipAlreadyInventoried:
    "Gerät ist bereits inventarisiert",
  toolAdministrationInventoryColumnActionUploadPhotoTooltipNotInventoryPeriod:
    "Die Inventur ist abgeschlossen",
  toolAdministrationInventoryColumnActionExportNameplateTooltip:
    "Typenschild als PDF-Datei exportieren",
  toolAdministrationInventoryDeleteDialogTitle: "Inventarisierung löschen",
  toolAdministrationInventoryDeleteDialogButton: "Löschen",
  toolAdministrationInventoryDeleteDialogMessage:
    "Möchtest du die Inventarisierung wirklich löschen?",
  notificationsTitle: "Benachrichtigungen",
  notificationsToday: "Heute",
  notificationsMarkAsRead: "Alle als gelesen markieren",
  notificationsSender: "Geändert durch",
  notificationsSubject: "Gerät/Baustelle",
  notificationsOccurrence: "Vorgang",
  notificationsTime: "Uhrzeit",
  notificationsDescription: "Beschreibung",
  notificationsDescriptionToolAvailability: "Verfügbarkeit",
  notificationsDescriptionFromTo: 'geändert von "{from}" zu "{to}"',
  notificationsDescriptionTo: 'geändert zu "{to}"',
  notificationsDescriptionResponsibleEmployee: "Verantwortliche/r",
  notificationsDescriptionToolAvailable: `geändert zu <strong>"verfügbar"</strong>`,
  notificationsDescriptionToolAssignedForYou: `geändert zu <strong>"vorgemerkt"</strong> für dich`,
  notificationsDescriptionToolAssignedForSomeoneElse: `geändert zu <strong>"vorgemerkt"</strong> für {employee}`,
  notificationsDescriptionToolTaken: `geändert zu <strong>"vergeben"</strong>`,
  notificationsDescriptionToolReturned: 'Zurückgegeben von "{by}"',
  notificationsDescriptionManager: "Manager",
  notificationsDescriptionToolPermanentDecommissioned:
    'Mit dem {decommissionedAt} ist das Gerät von "{employee}" mit dem Grund "{decommissionReason}" stillgelegt worden',
  notificationsDescriptionToolPermanentRecommissioned:
    "Das Gerät wurde reaktiviert.",
  notificationsDescriptionPhotoDocUploadedOne:
    "Ein neues Foto wurde hochgeladen",
  notificationsDescriptionPhotoDocUploadedMany:
    "{count} neue Fotos wurden hochgeladen",
  photoDocUploaded: "Fotos hochgeladen",
  notificationsPhotoDocUploadedLink: "Zur Foto-Dokumentation",
  notificationsFilterUnread: "Ungelesen",
  notificationsEmptyResult:
    "Für die ausgewählten Suchkriterien konnten keine Benachrichtigungen gefunden werden.",
  organigram: "Organigramm",
  organigramSettings: "Einstellungen",
  organigramExportAsPdf: "Organigramm als PDF exportieren",
  organigramOrganizationTitle: "Standort",
  organigramExpandAll: "Alles ausklappen",
  organigramCollapseAll: "Alles einklappen",
  organigramCompact: "Kompakte Ansicht",
  organigramLayout: "Layout",
  organigramLayoutLeft: "Layout: linksbündig",
  organigramLayoutRight: "Layout: rechtsbündig",
  organigramLayoutTop: "Layout: oben",
  organigramLayoutBottom: "Layout: unten",
  organigramDisplayHeaderFooter: "Kopf-/Fußzeile einblenden",
  organigramDisplayHeader: "Kopfzeile einblenden",
  organigramDisplayFooter: "Fußzeile einblenden",
  organigramNodeColorGroupTitle_greyLight: "Höhere Führungsrollen",
  organigramNodeColorGroupTitle_greyDark: "Leitungs- und Spezialfunktionen",
  organigramNodeColorGroupTitle_greenDark: "Vorarbeiter und Fachplanung",
  organigramNodeColorGroupTitle_greenLight:
    "Operative und administrative Rollen",
  organigramNodeColorGroupTitle_greenLightest: "Auszubildende",
  organigramNodeColorGroupTitle_white: "Assistenz- und unterstützende Rollen",
  wageTypeChargeableHours: "Produktivstunden",
  wageTypeVacation: "Urlaub",
  wageTypeVacationAbbreviation: "U",
  wageTypeIllness: "Krankheit",
  wageTypeIllnessAbbreviation: "K",
  wageTypeBankHolidays: "Feiertag",
  wageTypeBankHolidaysAbbreviation: "F",
  wageTypeCommuting: "Wegegeld-Fahrzeit",
  wageTypeCommutingAbbreviation: "W",
  wageTypeTraining: "Weiterbildung / Schule",
  wageTypeTrainingAbbreviation: "W/S",
  wageTypePreparation: "Lade- und Rüstzeit",
  wageTypePreparationAbbreviation: "L/R",
  wageTypeAdministration: "Verwaltung",
  wageTypeUnknown: "Unbekannt",
  wageTypeAdministrationAbbreviation: "V",
  wageTypeNumber: "Lohnartnummer",
  resetAppData: "Alle App-Daten zurücksetzen",
  resetAppDataConfirmTitle: "App-Daten zurücksetzen",
  resetAppDataConfirmText:
    "Wir machen hier mal richtig sauber - aber keine Sorge, dein Account und deine Daten bleiben natürlich! Danach einfach neu einloggen und weiter geht's.",
  resetAppDataConfirmButtonText: "Mach's sauber",
  taskBarTitle: "Meine Aufgaben",
  controllingKeyFigures: "Controlling Planung",
  controllingKeyFiguresControllingDataMenu: "Controlling-Daten",
  controllingKeyFiguresRevenueTargetsMenu: "Budget-Daten",
  controllingKeyFiguresDescription: "Überblicke die Controlling Planung.",
  controllingKeyFiguresBreadcrumbs: "Controlling Planung",
  controllingKeyFiguresBusinessLine: "Geschäftsfeld",
  controllingKeyFiguresProfitContributionPerHour: "Deckungsbeitrag pro Stunde",
  controllingKeyFiguresPlannedProfitContributionByBusinessLine:
    "Deckungsbeitrag pro Stunde",
  controllingKeyFiguresMonthlyHoursByBusinessLine: "Monatliche Stunden",
  controllingKeyFiguresMonthlyProfitContributionByBusinessLine:
    "Monatlicher Deckungsbeitrag",
  controllingKeyFiguresTotal: "Gesamt",
  controllingKeyFiguresNothingToSeeTitle: "Keine Kennzahlen",
  controllingKeyFiguresNothingToSeeContent:
    "Aktuell sind keine Kennzahlen verfügbar.",
  euroPerHour: "€ pro Stunde",
  businessLine_administration: "Verwaltung",
  businessLine_construction: "Neubau",
  businessLine_maintenance: "Instandhaltung",
  businessLine_tree_care: "Baum",
  businessLine_open_space_management: "Freiflächenmanagement",
  businessLine_pass_through: "Durchläufer",
  businessLine_unknown: "Unbekannt",
  workshop_hannover: "Werkstatt Hannover",
  workshop_bremen: "Werkstatt Bremen",
  workshop_rotenburg: "Werkstatt Rotenburg",
  workshop_wentorf: "Werkstatt Wentorf",
  projectUnknown: "Unbekannt",
  monthlyTargetsUploadButton: "Datei hochladen",
  monthlyTargetsUploadSuccess: "Daten gespeichert.",
  monthlyTargetsUploadFailed: "Fehler beim Speichern der Daten.",
  monthlyEmployeeTargetsButton: "Mitarbeiter-Planstunden",
  monthlyEmployeeTargetsUploadButton: "Hochladen",
  monthlyEmployeeTargetsUploadSuccess: "Daten gespeichert.",
  monthlyEmployeeRevenueTargetsUploadSuccess:
    "{fileCount} Dateien erfolgreich gespeichert.",
  monthlyEmployeeRevenueTargetsUploadUnknownError:
    "{filename} konnte aufgrund eines unbekannten Fehlers nicht gespeichert werden.",
  monthlyEmployeeTargetsUploadFailed: "Fehler beim Speichern der Daten.",
  monthlyEmployeeTargetsErrorMultipleYearsInFile:
    "Die Datei enthält mehrere Jahre",
  monthlyEmployeeTargetsErrorRow: "Zeile %{rowNumber} hat folgende Fehler",
  monthlyEmployeeTargetsErrorInvalidRow:
    "Zeile bereits vorhanden: Kürzel: %{tenant}, Ma-Nr: %{staffNumber}, Geschäftsfeld: %{businessLineCode}, Jahr: %{year}",
  monthlyEmployeeTargetsErrorBusinessLineUnknown:
    "Geschäftsfeld unbekannt: %{businessLineCode}",
  monthlyEmployeeTargetsMoreErrors: "Noch weitere Zeilen enthalten Fehler...",
  monthlyEmployeeTargetsError_tenant_required: "Kürzel fehlt",
  monthlyEmployeeTargetsError_staff_number_required: "MA.-NR fehlt",
  monthlyEmployeeTargetsError_business_line_code_required:
    "Geschäftsfeld fehlt",
  monthlyEmployeeTargetsError_wage_type_required: "Zuordnung fehlt",
  monthlyEmployeeTargetsError_year_required: "Jahr fehlt",
  monthlyEmployeeTargetsError_tenant_unknown: "Mandant unbekannt",
  unknownBackendError: "Ungültig",
  manageWageTypes: "Lohnarten",
  manageWageTypesDescription: "Prüfe, wie Lohnarten interpretiert werden.",
  manageWageTypesTableHeaderName: "Name",
  manageWageTypesTableHeaderNumber: "Nummer",
  manageWageTypesTableHeaderImportInterpretation: "Import interpretation",
  manageWageTypesTableHeaderExportInterpretation: "Export interpretation",
  manageWageTypesTableHeaderCount: "# Buchungen",
  navigationGroup_time: "Zeitmanagement",
  navigationGroup_resources: "Ressourcen",
  navigationGroup_planning: "Planung",
  navigationGroup_controlling: "Controlling",
  navigationGroup_health: "Health-Board",
  dashboardGreeting: "Moin",
  dashboardAddImages: "Bilder hinzufügen",
  dashboardDirectLinksTitle: "Direkt zu …",
  dashboardDirectLinksCallbackPortal: "Digitales Rückrufportal öffnen",
  exportButtonLabel: "Exportieren",
  exportButtonErrorMessage:
    "Beim Exportieren ist etwas schiefgelaufen. Bitte versuche es später erneut.",
  resourceTypeSelectLabel: "Mitarbeitende/Geräte",
  resourceTypeSelectOptionAll: "Alle",
  resourceTypeSelectOptionEmployee: "Nur Mitarbeitende",
  resourceTypeSelectOptionTool: "Nur Geräte",
  teamDeletedTooltip: "Kolonne wurde gelöscht",
  azureTeamSyncButton: "Mit Teams synchronisieren",
  azureTeamSyncButtonSyncMembers: "Mit Teams synchronisieren",
  azureTeamSyncButtonRetry: "Teams-Sync neu versuchen",
  azureTeamSyncStatusSyncing: "Teams-Sync in Bearbeitung",
  azureTeamSyncStatusSynced: "Mit Teams synchronisiert",
  azureTeamSyncStatusCompactPrefix: "Teams:",
  azureTeamSyncStatusCompactSyncing: "In Bearbeitung",
  azureTeamSyncStatusCompactSynced: "Synchronisiert",
  azureTeamSyncStatusCompactMembersNotSynced: "Mitglieder nicht synchronisiert",
  azureTeamSyncStatusArchived: "Team archiviert",
  azureTeamSyncStatusCompactArchived: "Archiviert",
  azureTeamSyncArchivedTooltip:
    "Das Team wurde archiviert, weil die Baustelle abgeschlossen ist. Es bleibt in Teams unter „Archiviert“ lesbar.",
  azureTeamSyncErrorArchived:
    "Das Team ist archiviert, weil die Baustelle abgeschlossen ist. Eine Synchronisation ist nicht mehr möglich.",
  azureTeamSyncDisabledTooltip:
    "Die Änderungen müssen zuerst gespeichert werden, bevor die Synchronisation mit MS Teams möglich ist.",
  azureTeamSyncModalTitle: "MS Teams-Synchronisation",
  azureTeamSyncModalInfoText:
    "Das synchronisieren mit Microsoft Teams kann bis zu <strong>2 Tage</strong> in Anspruch nehmen.",
  azureTeamSyncModalCreateLabel: "Neues Team erstellen und verbinden",
  azureTeamSyncModalConnectLabel: "Mit einem bestehendem Team verbinden",
  azureTeamSyncModalConnectInputLabel: "Teams-Link einfügen",
  azureTeamSyncModalConnectInputErrorInvalidLink:
    "Bitte füge einen gültigen Teams-Link ein",
  azureTeamSyncModalConnectInputErrorTeamNotFound:
    "Für diesen Link wurde kein Team gefunden.",
  azureTeamSyncModalConnectInputErrorTeamInUse:
    "Dieses Team ist bereits mit einer anderen Baustelle verbunden.",
  azureTeamSyncModalNamePreview:
    'Die neue Gruppe wird in Teams unter "{teamName}" zu finden sein.',
  azureTeamSyncModalAddEmployeesLabel: "Außerplanmäßige Mitarbeiter hinzufügen",
  azureTeamSyncModalSubmitButton: "Synchronisieren",
  azureTeamSyncErrorText:
    "Die Synchronisation mit Teams ist fehlgeschlagen. Versuche es ruhig erneut, deine System-Administratoren wurden bereits über den Fehler informiert.",
  emptySearchResult:
    "Für die ausgewählten Suchkriterien konnten keine Einträge gefunden werden.",
  workingTimeMissing:
    "Die/Der Mitarbeitende(r) war zum angegebenen Datum noch nicht angestellt.",
  quickCheckInCheckOutDialogHeaderArrival: "Hinweg bearbeiten",
  quickCheckInCheckOutDialogHeaderDeparture: "Rückweg bearbeiten",
  quickCheckInCheckOutDialogResourceTitleArrival: "Hinweg von {resourceName}",
  quickCheckInCheckOutDialogResourceTitleDeparture:
    "Rückweg von {resourceName}",
  quickCheckInCheckOutDialogResourceSubtitleArrival:
    "Woher kommt {resourceName}?",
  quickCheckInCheckOutDialogResourceSubtitleDeparture:
    "Wohin fährt {resourceName} nun?",
  quickCheckInCheckOutDialogDriverSiteArrivalButtonLabel:
    "<b>Vom Betriebshof</b> als <b>Fahrer/in</b>",
  quickCheckInCheckOutDialogDriverSiteDepartureButtonLabel:
    "<b>Zum Betriebshof</b> als <b>Fahrer/in</b>",
  quickCheckInCheckOutDialogPassengerSiteArrivalButtonLabel:
    "<b>Vom Betriebshof</b> als <b>Beifahrer/in</b>",
  quickCheckInCheckOutDialogPassengerSiteDepartureButtonLabel:
    "<b>Zum Betriebshof</b> als <b>Beifahrer/in</b>",
  quickCheckInCheckOutDialogDriverHomeArrivalButtonLabel:
    "<b>Von Zuhause</b> als <b>Fahrer/in</b>",
  quickCheckInCheckOutDialogDriverHomeDepartureButtonLabel:
    "<b>Nach Hause</b> als <b>Fahrer/in</b>",
  quickCheckInCheckOutDialogPassengerHomeArrivalButtonLabel:
    " <b>Von Zuhause</b> als <b>Beifahrer/in</b>",
  quickCheckInCheckOutDialogPassengerHomeDepartureButtonLabel:
    "<b>Nach Hause</b> als <b>Beifahrer/in</b>",
  quickCheckInCheckOutDialogNoCommuteButtonLabel: "Kein Wegegeld",
  todayButtonTooltip: "Heute",
  listEndReachedFooterTitle: "Du hast das Ende erreicht.",
  listEndReachedFooterText:
    "Suchst du noch mehr? Überprüfe, ob deine gesuchten Einträge den Filter-Kriterien oben entsprechen.",
  responsibilityActionMenuButtonLabelAvailable: "Verfügbar",
  responsibilityActionMenuButtonLabelAssignedForMe: "Für dich vorgemerkt",
  responsibilityActionMenuButtonLabelAssignedForSomeoneElse: "Vorgemerkt",
  responsibilityActionMenuButtonLabelTakenByMe: "Bei mir",
  responsibilityActionMenuButtonLabelTakenBySomeoneElse: "Vergeben",
  responsibilityActionMenuItemTake: "Übernehmen",
  responsibilityActionMenuItemAssign: "Vormerken",
  responsibilityActionMenuItemMakeAvailable: "Verfügbar machen",
  responsibilityActionMenuItemAccept: "Annehmen",
  responsibilityActionMenuItemReject: "Ablehnen",
  responsibilityActionMenuItemReturn: "Zurückgeben",
  assignToolDialogTitle: "Gerät für Mitarbeitenden vormerken",
  assignToolDialogAssignButtonLabel: "Vormerken",
  assignToolDialogEmployeeSelectLabel: "Suche",
  assignToolDialogEmployeeSelectError: "Bitte einen Mitarbeiter auswählen",
  toolCardAssignedToYouHeader: "Für dich vorgemerkt von",
  constructionSiteMonitorPopoverTitle: "Baustellenmonitor",
  constructionSiteMonitorPopoverCalculatedLabel:
    "Gesamtkalkulation aus dem Angebot",
  constructionSiteMonitorPopoverDistributedLabel:
    "Kalkulierte Stunden aus den Arbeitspaketen",
  constructionSiteMonitorPopoverPlannedLabel:
    "Geplante Stunden aus den Arbeitspaketen",
  constructionSiteMonitorPopoverActualLabel: "Ist-Stunden",
  trainingNoteModalHeader: "Bemerkung zur Weiterbildung",
  noToolsInPreparationPlanningsInfo:
    "Planungen für Lade- und Rüstzeit dürfen keine Geräte enthalten.",
  calculatedHoursShadowedTooltip:
    "Geplante Stunden werden als kalkulierte Stunden angenommen.",
  invalid: "ungültig",
  openConstructionSiteMonitorDetails: "Baustellenmonitor-Details anzeigen",
  constructionSiteMonitorWarning:
    'Die kalkulierten oder geplanten Stunden sind noch nicht verteilt. Prüfe die Eingabefelder "Kalkulierte Stunden" und "Geplante Stunden" in deinen Arbeitspaketen.',
  hoursExceeded: "Überschritten",
  hoursCritical: "Kritisch",
  hoursWarning: "Achtung",
  actualPlannedHours: "Ist- / Plan-Stunden",
  actualHours: "Ist-Stunden",
  trackingOverviewMonitorInvalid: "Keine Plandaten hinterlegt.",
  trackingOverviewOfflineMessage:
    "Du bist gerade offline. Die Zeiten werden sich erst bei der nächsten Verbindung zum Internet aktualisieren.",
  of: "von",
  hours: "Stunden",
  showInfo: "Details anzeigen",
  noPlannedHours: "Keine Planstunden hinterlegt",
  autocompleteAllOption: "Alle auswählen",
  autocompleteTooManyOptionsSelected:
    "Es dürfen maximal {maxEntries} Einträge ausgewählt werden.",
  exportUploadMenuUploadItem: "Hochladen",
  exportUploadMenuExportItem: "Exportieren",
  documentUploadInfo:
    "Dokumente per Drag and Drop in diese Box ziehen, um sie hochzuladen.",
  documentUploadLabel: "Dokumente wählen",
  documentsSegment: "Alle Dateien",
  documentUploadSegment: "Dateien hochladen",
  toolDrawerDetailsTab: "Details",
  toolDrawerDocumentsTab: "Dokumente",
  toolDrawerInventoryTab: "Inventur",
  toolDrawerTabsLabel: "Geräte-Tabs",
  toolDrawerLabel: "Geräte-Drawer",
  documentUploadSuccessful: "Upload erfolgreich abgeschlossen.",
  documentUploadFailed: "Upload fehlgeschlagen",
  toolDocumentsLabel: "Dokumente",
  toolDocumentsEmpty: "Noch keine Dokumente hinterlegt.",
  fileName: "Dokument",
  deleteDocumentSuccessful: "Dokument erfolgreich gelöscht.",
  deleteDocumentLabel: "{documentName} löschen",
  toolId: "ID",
  deleteDocumentConfirmButtonText: "Weg damit",
  deleteDocumentConfirmText:
    "Das Dokument wird unwiderruflich geschreddert. Bist du sicher?",
  missingProjectNumbersExportButtonLabel: "Fehlende Projektnummern",
  toolAdministrationToolView: "Geräteansicht",
  toolAdministrationInventoryView: "Inventuransicht",
  absenceInfoShowInfo: "Abwesenheitsdetails anzeigen",
  controllingProjectShowMetaInfo: "Projektdetails anzeigen",
  unallocated: "Noch nicht verteilt",
  expandWorkPackage: 'Arbeitspaket "{name}" aufklappen',
  collapseWorkPackage: 'Arbeitspaket "{name}" zuklappen',
  photoDocumentationUploadAddImagesButton: "Fotos hinzufügen",
  photoDocumentationUploadWorkPackageSectionTitle: "Arbeitspaket",
  photoDocumentationUploadChooseWorkPackage: "Arbeitspaket wählen",
  photoDocumentationUploadChangeWorkPackage: "Arbeitspaket ändern",
  photoDocumentationUploadComment: "Kommentar",
  photoDocumentationUploadButton: "Fotos hochladen",
  photoDocumentationUploadInfo:
    "Die Fotos werden im Hintergrund hochgeladen. Sobald der Upload abgeschlossen ist, wirst du benachrichtigt.",
  photoDocumentationUploadHeicHint:
    "Für dieses Bildformat ist keine Vorschau verfügbar. Die Bilder werden trotzdem hochgeladen und automatisch in das JPG-Format umgewandelt.",
  photoDocumentationUploadQueuing: "Wird vorbereitet…",
  photoDocumentationUploadSuccess:
    "Foto-Dokumentation für Arbeitspaket {workPackageName} erfolgreich hochgeladen.",
  photoDocumentationUploadExpired:
    "Das Hochladen der Foto-Dokumentation für Arbeitspaket {workPackageName} ist fehlgeschlagen. Bitte versuche es erneut.",
  photoDocumentationUploadFailed:
    "Foto-Dokumentation für Arbeitspaket {workPackageName} konnte nicht hochgeladen werden.",

  photoDocumentationUploadWorkPackageSearchPlaceholder:
    "Suche nach Name, Baustellen-NR, Adresse...",
  photoDocumentationUploadWorkPackageListTitle: "Letzte Arbeitspakete",
  photoDocumentationUploadWorkPackageEmptyState: "Keine Arbeitspakete",
  photoDocumentationUploadWorkPackageNoResults: "Keine Arbeitspakete gefunden",
  photoDocumentationUploadError: "Fehler beim Hochladen des Fotos",
  photoDocumentationUploadFilesTooLarge:
    "{count} Foto(s) wurden übersprungen, da sie die maximale Größe von {maxSizeMb} MB überschreiten.",
  photoDocumentationUploadMaxPhotosReached:
    "Maximale Anzahl von {maxCount} Fotos erreicht. Weitere Fotos wurden nicht hinzugefügt.",
  photoDocumentationWorkPackagesError:
    "Arbeitspakete konnten nicht geladen werden",
  photoDocumentationUploadWorkPackageSectionManager: "Bauleiter",
  photoDocumentationUploadWorkPackageListTitleRecent: "Letzte Arbeitspakete",
  photoDocumentationUploadWorkPackageListTitleByManager:
    "Arbeitspakete von {managerName}",
  photoDocumentationUploadWorkPackageListTitleAll: "Alle Arbeitspakete",
  photoDocumentationUploadWorkPackageListTitleOtherManagers:
    "Arbeitspakete anderer Bauleitender",
  photoDocumentationUploadManagerCardDescription:
    "Wähle deinen Bauleiter, wenn die Bilder zu keinem Arbeitspaket gehören sollen.",
  photoDocumentationManagerAccountFormTitle: "Auftrag erfassen",
  photoDocumentationManagerAccountFormCustomerName:
    "Kundenname / Ansprechpartner",
  photoDocumentationManagerAccountFormStreet: "Straße",
  photoDocumentationManagerAccountFormHouseNumber: "Haus-Nr.",
  photoDocumentationManagerAccountFormZip: "PLZ",
  photoDocumentationManagerAccountFormCity: "Ort",
  photoDocumentationManagerAccountFormPhone: "Telefonnummer",
  photoDocumentationManagerAccountFormDescription:
    "Kundenauftrag / Beschreibung der Baustelle",
  photoDocumentationFetchingGeoPosition: "Geo-Position wird ermittelt...",
  photoDocumentationFailedMobileUploadsTitle: "Fehlgeschlagene Mobil-Uploads",
  photoDocumentationFailedMobileUploadsHint:
    "Auf dem Smartphone konnten Uploads nicht erfolgreich abgeschlossen werden. Öffne die grewe-gruppe App auf deinem Smartphone, um den Upload erneut zu versuchen.",
  photoDocumentationUploadQueueTitle: "Upload-Warteschlange",
  photoDocumentationUploadQueueEmpty:
    "Alle Bilder wurden hochgeladen, es befindet sich keins in der Warteschlange.",
  photoDocumentationUploadQueueOfflineHint:
    "Du bist offline, der Upload wird fortgeführt, sobald du wieder mit dem Internet verbunden bist.",
  photoDocumentationUploadQueueRetry: "Erneut versuchen",
  photoDocumentationUploadQueueDiscard: "Verwerfen",
  photoDocumentationUploadQueueStatusPending:
    "Wartet in der Warteschlange - Uploads werden nacheinander verarbeitet",
  photoDocumentationUploadQueueStatusUploading: "Wird gerade hochgeladen",
  photoDocumentationUploadQueueStatusCompleted: "Erfolgreich hochgeladen",
  photoDocumentationUploadQueueStatusFailed: "Upload fehlgeschlagen",
  photoDocumentationUploadQueueStatusExpired:
    "Upload abgelaufen – tippe auf Erneut versuchen, um ihn neu zu starten",
  photoDocumentationUploadQueueStatusOffline:
    "Kein Internet - Upload wird fortgesetzt, wenn du wieder online bist",
  photoDocumentationUploadQueueGalleryTitle: "Fotos",
  photoDocumentationUploadPanelTitle: "Fotos hochladen",
  photoDocumentationUploadDropZoneHint:
    "Fotos per Drag and Drop in diese Box ziehen, um sie hochzuladen.",
  photoDocumentationUploadDropZoneOr: "oder",
  photoDocumentationUploadChooseFilesButton: "Fotos wählen",
  photoDocumentationBurstCameraTakePhotos: "Foto schießen",
  photoDocumentationBurstCameraViewfinder: "Live-Kamerabild",
  photoDocumentationBurstCameraShutter: "Foto aufnehmen",
  photoDocumentationBurstCameraDone: "Fertig ({count})",
  photoDocumentationBurstCameraStarting: "Kamera wird gestartet…",
  photoDocumentationBurstCameraResuming: "Kamera wird fortgesetzt…",
  photoDocumentationBurstCameraCheckPhoto: "Foto {position} prüfen",
  photoDocumentationBurstCameraRemovePhoto: "Foto {position} entfernen",
  photoDocumentationBurstCameraPhotoPending: "Foto wird gespeichert",
  photoDocumentationBurstCameraBackToCamera: "Zurück zur Kamera",
  photoDocumentationBurstCameraKeepPhoto: "Behalten",
  photoDocumentationBurstCameraDeletePhoto: "Löschen",
  photoDocumentationBurstCameraDiscardTitle: "Fotos verwerfen?",
  photoDocumentationBurstCameraDiscardMessage:
    "{count} Fotos dieser Serie werden verworfen und nicht hochgeladen.",
  leisureTimeAccount: "Freizeitkonto",
  leisureTimeAccountTooltip:
    "Dein Freizeitkonto aktualisiert sich spätestens mit der Lohnabrechnung.",
  timeWorkedHeading: "Hier steht, was du schon gearbeitet hast...",
  leisureTimeAccountHeading: "Und hier ist dein Freizeit-Polster...",
  leisureTimeAccountLastUpdated: "Zuletzt aktualisiert:",
  vacationEntitlement: "Urlaubsanspruch",
  vacationEntitlementTooltipWhiteCollarWorker:
    "Dein Urlaubsanspruch aktualisiert sich mit jeder Gehaltsabrechnung.",
  vacationEntitlementTooltip:
    "Urlaubstage, die bereits für die Zukunft verplant sind, werden nicht berücksichtigt.",
  vacationEntitlementInclCarryover: "Urlaubsanspruch inkl. Resturlaub",
  vacationEntitlementTaken: "Genommen",
  vacationEntitlementPlanned: "Verplant",
  vacationEntitlementRemaining: "Übrig",
  vacationEntitlementTakenTooltip:
    "Aktualisiert sich mit jeder Gehaltsabrechnung.",
  vacationEntitlementPlannedTooltip:
    "Es werden nur die Urlaubstage berücksichtigt, die in den Abwesenheiten der ggA eingetragen worden sind.",
  revealValue: "Wert anzeigen",
  revealLabel: "Titel anzeigen",
  photoDocumentationDescription: "Übersicht der hochgeladenen Bilder",
  photoDocumentation: "Foto-Dokumentation",
  photoDocumentationViewTitle: "Meine Bilder",
  photoDocumentationViewSitesTitle: "Baustellen",
  photoDocumentationViewRecent: "Zuletzt",
  photoDocumentationViewColumnPhoto: "Foto",
  photoDocumentationViewColumnDate: "Datum",
  photoDocumentationViewColumnLocation: "Ort",
  photoDocumentationViewColumnAuthor: "Autor",
  photoDocumentationViewColumnComment: "Kommentar",
  photoDocumentationViewColumnAction: "Aktion",
  photoDocumentationViewNoRecentPhotos: "Keine aktuellen Fotos",
  photoDocumentationViewNoSites:
    "Keine Baustellen mit Foto-Dokumentation verfügbar",
  photoDocumentationViewNoSearchResults:
    "Für die ausgewählten Suchkriterien konnten keine Foto-Dokumentation gefunden werden.",
  photoDocumentationViewUploadPeriod: "Upload-Zeitraum",
  photoDocumentationViewDateRangeLabel: "Zeitraum",
  photoDocumentationViewLoadingWorkPackages:
    "Leistungspositionen werden geladen",
  photoDocumentationViewWorkPackagePhotosError:
    "Fotos konnten nicht geladen werden",
  photoDocumentationViewPhotosCount: "Fotos",
  photoDocumentationViewNoPhotosInPeriod:
    "Keine Fotos für den angegebenen Zeitraum",
  photoDocumentationViewDeepLinkUnavailable:
    "Die Fotos sind nicht mehr verfügbar",
  photoDocHistoryTitle: "Historie der Foto-Dokumentation",
  photoDocHistoryTitlePrefix: "Historie von",
  photoDocHistoryLoading: "Historie wird geladen",
  photoDocHistoryError: "Historie konnte nicht geladen werden",
  photoDocHistoryEmpty: "Keine Historie vorhanden",
  photoDocHistoryColumnDate: "Datum",
  photoDocHistoryColumnTime: "Uhrzeit",
  photoDocHistoryColumnOperation: "Vorgang",
  photoDocHistoryColumnChangedBy: "Geändert durch",
  photoDocHistoryColumnWorkPackage: "Baustelle / Arbeitspaket",
  photoDocHistoryColumnDescription: "Beschreibung",
  photoDocHistoryEventUploaded: "Hochgeladen",
  photoDocHistoryEventAssigned: "Zugeordnet",
  photoDocHistoryEventAssignedWorkPackage: "Zugeordnet",
  photoDocHistoryEventAssignedManager: "Bauleiter zugeordnet",
  photoDocHistoryEventDeleted: "Gelöscht",
  photoDocHistoryEventPhotoDeleted: "Gelöscht",
  photoDocHistoryDescriptionUploaded: "Die Foto-Dokumentation wurde erstellt.",
  photoDocHistoryDescriptionAssigned:
    "Die Foto-Dokumentation wurde einem Arbeitspaket zugeordnet.",
  photoDocHistoryDescriptionAssignedWorkPackage:
    "Die Foto-Dokumentation wurde einem Arbeitspaket zugeordnet.",
  photoDocHistoryDescriptionManager:
    "Die Foto-Dokumentation wurde einem Bauleiter zugeordnet.",
  photoDocHistoryDescriptionAssignedManager:
    'Die Foto-Dokumentation wurde "{name}" zugeordnet.',
  photoDocHistoryDescriptionDeleted: "Die Foto-Dokumentation wurde gelöscht.",
  photoDocHistoryDescriptionPhotoDeleted: 'Das Bild "{name}" wurde gelöscht.',
  photoDocHistoryDescriptionPhotoDeletedFallback: "Ein Bild wurde gelöscht.",
  photoDocHistoryOpenLabel: "Historie anzeigen",
  photoDocumentationViewSearchPlaceholder:
    "Baustelle, Arbeitspaket, Bauleiter oder Kundenname suchen",
  photoDocumentationViewSearchPlaceholderMobile:
    "Baustelle, Arbeitspaket oder Bauleiter suchen",
  photoDocumentationViewInfoIconLabel: "Bildinformationen anzeigen",
  photoDocumentationViewNoComment: "Kein Kommentar",
  photoDocumentationViewShowLocation: "Standort auf Karte öffnen",
  photoDocumentationViewManagerAccountLabel: "Bauleiter",
  photoDocAssignDialogTitle: "Foto-Dokumentation zuordnen",
  photoDocAssignButton: "Zuordnen",
  photoDocAssignRadioGroupLabel: "Foto-Dokumentation zuordnen",
  photoDocAssignSuccess: "Foto-Dokumentation erfolgreich zugeordnet",
  photoDocAssignWorkPackage: "Arbeitspaket zuordnen",
  photoDocAssignConstructionSiteManager: "Anderem Bauleitenden zuordnen",
  photoDocAssignWorkPackageLabel: "Arbeitspaket",
  photoDocAssignWorkPackageError: "Bitte wähle ein Arbeitspaket",
  photoDocAssignConstructionSiteManagerLabel: "Bauleitende/r",
  photoDocAssignConstructionSiteManagerError:
    "Bitte wähle eine/n Bauleitende/n",
  photoDocumentationDeleteSingleDialogTitle: "Foto löschen?",
  photoDocumentationDeleteSingleDialogBody:
    "Das Foto {filename} wird in Teams in den Deleted-Ordner verschoben. Diese Aktion kann nicht rückgängig gemacht werden.",
  photoDocumentationDeleteGroupDialogTitle: "Foto-Gruppe löschen?",
  photoDocumentationDeleteGroupDialogBody:
    "Alle {count} Fotos dieser Gruppe vom {date} werden in Teams in den Deleted-Ordner verschoben. Diese Aktion kann nicht rückgängig gemacht werden.",
  photoDocumentationDeleteConfirmButton: "Löschen",
  photoDocumentationDeleteDisabledTooltip:
    "Fotos können nur innerhalb von einem Monat nach dem Upload gelöscht werden.",
  photoDocumentationDeleteSinglePhotoIconLabel: "Foto löschen",
  photoDocumentationDeleteGroupIconLabel: "Foto-Gruppe löschen",
  photoDocumentationDownloadGroupMenuLabel:
    "Herunterladen ({count} Fotos, ZIP)",
  photoDocumentationDownloadPhotoMenuLabel: "Herunterladen",
  photoDocumentationRowActionsLabel: "Weitere Aktionen",
  photoDocumentationDetailsMenuLabel: "Details",
  photoDocumentationDownloadErrorToast:
    "Der Download hat nicht funktioniert. Bitte erneut versuchen.",
  photoDocumentationDownloadTooLargeToast:
    "Diese Foto-Gruppe ist zu groß für einen Download am Stück. Bitte die Fotos einzeln herunterladen.",
  photoDocumentationDownloadIncompleteToast:
    "{count} Fotos konnten nicht geladen werden. Das Archiv enthält eine Liste der fehlenden Dateien.",
  photoDocumentationDownloadProcessingToast:
    "Einige Fotos werden noch verarbeitet. Bitte versuche es gleich noch einmal.",
  photoDocumentationDownloadProcessingHint: "Fotos werden noch verarbeitet",
  photoDocumentationDownloadNothingProcessedHint:
    "Kein Foto konnte verarbeitet werden",
  photoDocumentationPhotoProcessing: "Wird verarbeitet",
  photoDocumentationPhotoProcessingFailed:
    "Foto konnte nicht verarbeitet werden",
  photoDocumentationPhotoUnavailable: "Nicht verfügbar",
  photoDocumentationDownloadInProgressLabel: "Archiv wird vorbereitet",
  photoDocumentationDeleteOutsideWindowMenuHint:
    "Löschen ist nur im ersten Monat möglich",
  photoDocumentationOpenPhotoLabel: "Foto in neuem Tab öffnen",
  photoViewerOpenLabel: "Foto ansehen",
  photoViewerDialogLabel: "Fotoansicht",
  photoViewerCounter: "Foto {current} von {total}",
  photoViewerPrevious: "Vorheriges Foto",
  photoViewerNext: "Nächstes Foto",
  photoViewerShowPhoto: "Foto {number} anzeigen",
  photoViewerCurrentPhoto: "Foto {number}, aktuell",
  photoViewerLoading: "Foto wird geladen",
  photoViewerLoadError: "Das Foto konnte nicht geladen werden.",
  photoViewerLoadErrorHint:
    "Bitte prüfe deine Verbindung und versuche es erneut.",
  photoViewerRetry: "Erneut versuchen",
  photoDocumentationDeleteSuccessSnackbar: "Erfolgreich gelöscht.",
  photoDocumentationDeleteErrorSnackbar:
    "Löschen fehlgeschlagen. Bitte erneut versuchen.",
  moreInformation: "Mehr Informationen",
  moreInformationAbout: "Mehr Informationen zu",
  foreignTenantToolWarningTitle: "Gerät eines anderen Standorts hinzufügen",
  foreignTenantToolWarningMessage:
    "Achtung, das Gerät <strong>{toolDisplayName}</strong> gehört dem <strong>Standort {tenantName}</strong>. Bitte stelle sicher, dass du das richtige Gerät gewählt hast.",
  foreignTenantToolWarningConfirm: "Bestätigen",
  abilitiesMyAbilitiesTitle: "Meine Rechte",
  abilitiesCallbackPortalTitle: "Callback-Portal",
  abilitiesSoftgardenTitle: "Softgarden",
  abilitiesJobAbilitiesTitle: "Standardrechte für Job-Titel/Rollen",
} as const;
